/* REPLAY OVERLAY (2026-10-12, Rob on his #2386 replay: "We should be able to see what happened, what gifts were thrown, chats in
   the replay"). A live replay's chat rows, gift rows and battle, timed to the replay video, on every web surface that plays one
   (feed card, permalink, immersive viewer).
   - WHO: a <video data-lreplay="<post id>"> (views/_post.php stamps it on replay posts; data-lrec = the recording uid of that
     carousel part). Nothing runs until such a video PLAYS (one capture listener on document; media events do not bubble).
   - DATA: GET /post-replay?id=&from=&to=[&meta=1] (routes/livereplay.php -> LiveReplay::read): rows carry t_ms = ms into the
     replay; meta carries parts (carousel clock), battles (running score, result, MVPs, leagues) and FRAMING (below). Fetched
     LAZILY by 60 s window (the window under the playhead + the next one shortly before it is needed); a capped window continues
     from next_from_ms.
   - SYNC: timeupdate (and seeked / play) schedules ONE requestAnimationFrame render; nothing animates per frame, no rAF loop
     while paused. A seek re-syncs at once (rows of the last few seconds appear without the entrance animation).
   - THE LOOK (2026-10-12, Rob: "The replay looks horrible. It needs to look EXACTLY like it looked to viewers"). THE PLAYER OWNS
     THE FRAMING, phase by phase (meta.framing):
       battle  [intro_ms, result_end_ms) (+ the band's own tail). A REPLAY HAS ONLY THE HOST'S OWN RECORDING (2026-10-15, Rob on
               @cognac's #2828 replay: "This looks crazy and WRONG" -- her band letterboxed small in a gold-framed LEFT half, an EMPTY
               right half with the opponent's avatar). The recording plays WHOLE, at the post's own fit, never cropped or split
               (it already holds whatever her phone composited: the band, the room or her camera alone), and the battle UI is an
               OVERLAY on the picture: where the recording is a band composite (seamAt: the recorded layout framing.layouts 'band'
               tiles, db/0270, confirmed by the measured framing.band_runs once scanned; else framing.band inside a measured run)
               the VS disc sits on the recording's own seam, the opponent's chip on the opponent's tile, the clock pill on the
               band's bottom edge, the 3-2-1 / result strip over the band and the score bar right under it; with no band in the
               picture (camera only, or not measured yet and no recorded layout) the score bar runs along the picture's top with
               the clock under it -- no VS, no chip, never an empty opponent tile.
       call    framing.calls (a co-host grid / an Open Room in the picture): the whole frame (the post's fit hint), and name pills
               on the tiles when framing.layouts has them (db/0270, lives from 2026-10-12 on).
       solo    untouched: the clip plays the way every camera replay does.
   - TOGGLE: the replay chat on/off is a button in the PLAYER'S OWN control bar (.vctrl .vc-row, next to fullscreen / PiP),
     never over the picture; it hides chat + gift rows, the gift moments and the hearts on every replay (localStorage
     rova_lrp_chat = 0). No bar, no button.
   - EVERYTHING THE LIVE SHOWED (2026-10-12, Rob: "basically everything from the live should be seen on the replay"):
       gifts   each gift row plays the LIVE'S OWN gift moment at its time: assets/gifts.js's Player through its display-only door
               (window.__rovaGiftDisplay; gifts.js + gifts.css + GET /gifts/catalog loaded on the first gift row, their URLs on
               this script tag's data-gjs / data-gcss) on a `.gstage.gs-watch.gs-replay` layer: the lane pill with the art
               landing, the hero / full-screen / takeover moment, the xN count-up, the banner -- the live's sizes. Joined to
               the catalog by gift.id; the row's own 128 art is the fallback.
       hearts  `likes` [[t_ms, n]] on every window (n hearts over the 5 s from t_ms): the live's rising hearts, a few per bucket
               scaled by n (HEART_CAP per bucket, never a swarm), from a fixed pool of pooled nodes animated by WAAPI
               (transform + opacity), the same curve + colours as livechat.js.
       chat    chat / join / follow / system lines stay up until newer lines push them off (the room's list), never timed out;
               windows before the playhead are read back (contiguously) until the list is full.
       seeking only events within FX_WIN_MS of the playhead animate: a seek (or a loop) drops the gift stage and starts fresh,
               nothing skipped over replays in a burst.
       pause   paused / ended / offscreen = frozen: CSS animations paused (.lrp-paused), WAAPI animations paused, the gift
               particles + slot decoders paused, no heart timers.
       chapters replay.chapters [{t_ms, kind, label, ref_id}]: small marks on the player's seek bar + previous / next chapter
               buttons in its control row (only when there are chapters in this part).
   CSS: livereplay.css, linked on first use (its URL rides this script tag's data-css). Debug: window.__rovaReplay. */
(function () {
  'use strict';
  if (window.__rovaReplay) { return; }
  var SCRIPT = document.currentScript;
  var CSS_URL = (SCRIPT && SCRIPT.getAttribute('data-css')) || '/assets/livereplay.css';
  var GJS_URL = (SCRIPT && SCRIPT.getAttribute('data-gjs')) || '/assets/gifts.js';
  var GCSS_URL = (SCRIPT && SCRIPT.getAttribute('data-gcss')) || '/assets/gifts.css';
  var WIN = 60000;           // ms of replay per fetch
  var MAX_ROWS = 5;
  var MAX_ROWS_STAGE = 8;    // the battle stage has the room under the bar for more, like the live room
  var BACK_WINS = 10;        // read back at most this many windows before the playhead to fill the list (a quiet stretch)
  var FX_WIN_MS = 1000;      // a gift / a heart animates only within this long of its moment (a seek never replays a burst)
  var HEART_LEAD = 400;      // heart timers are set this far ahead of the playhead (timeupdate comes ~4x a second)
  var HEART_CAP = 15;        // hearts per 5 s bucket at most (the live floats <= 12 per 2 s poll; a replay never swarms)
  var PREFETCH_MS = 15000;   // fetch the next window this long before the playhead reaches it
  var TAIL_MS = 8000;        // a battle stays on screen at least this long after its result shows
  var LRP_IDLE_GUT = 12;     // px from the last chat row to the picture's bottom while the viewer's chrome rests (= the awake floor)
  var LS_KEY = 'rova_lrp_chat';
  var posts = {};            // post id -> shared data {meta, rows[], keys{}, wins{}, dead, metaP}
  var views = typeof WeakMap === 'function' ? new WeakMap() : null;
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var chatOn = true;
  try { chatOn = localStorage.getItem(LS_KEY) !== '0'; } catch (e) {}
  var cssDone = false;

  function ensureCss() {
    if (cssDone) { return; }
    cssDone = true;
    if (document.querySelector('link[data-lrp-css]')) { return; }
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = CSS_URL; l.setAttribute('data-lrp-css', '1');
    document.head.appendChild(l);
  }

  /* ---------------- THE GIFT KIT: gifts.js (its display-only Player) + gifts.css + the catalog, once per page ---------------- */
  var TIERS0 = [{ tier: 1, ms: 1600 }, { tier: 2, ms: 2600 }, { tier: 3, ms: 5200 }, { tier: 4, ms: 8500 }];
  var kitP = null;
  function loadOnce(tag, attrs, test) {
    return new Promise(function (resolve) {
      if (test()) { resolve(true); return; }
      var n = document.createElement(tag), done = false;
      var fin = function (ok) { if (!done) { done = true; resolve(ok); } };
      Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
      n.onload = function () { fin(true); }; n.onerror = function () { fin(false); };
      setTimeout(function () { fin(test()); }, 15000);
      (tag === 'link' ? document.head : document.body || document.head).appendChild(n);
    });
  }
  function giftKit(noCat) {
    if (kitP) { return kitP; }
    var js = loadOnce('script', { src: GJS_URL, 'data-lrp-gifts': '1' }, function () { return typeof window.__rovaGiftDisplay === 'function'; });
    var cs = loadOnce('link', { rel: 'stylesheet', href: GCSS_URL, 'data-lrp-gcss': '1' }, function () { return !!document.querySelector('link[data-lrp-gcss],link[href*="/gifts."][rel="stylesheet"]'); });
    // the rows carry the full display fields (art_512, anim, duration_ms...; 2026-10-12, guests too): the catalog only for older answers
    var cat = noCat ? Promise.resolve(null) : fetch('/gifts/catalog', { credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { return j && j.ok && Array.isArray(j.gifts) ? j : null; }, function () { return null; });
    kitP = Promise.all([js, cs, cat]).then(function (a) {
      if (typeof window.__rovaGiftDisplay !== 'function') { return null; }
      var c = a[2] || {}, by = {};
      (c.gifts || []).forEach(function (g) { by[g.id] = g; });
      return { catalog: { gifts: c.gifts || [], tiers: c.tiers && c.tiers.length ? c.tiers : TIERS0 }, byId: by };
    }, function () { return null; });
    return kitP;
  }
  /* THE GIFT A ROW PLAYS: the row's own display fields when it carries them (the replay rows gain large art / anim / duration_ms /
     where / tier_key for everyone, guests included, who cannot read the catalog), then the catalog's entry, then the row's 128 art */
  function giftFor(rg, kit) {
    var base = (kit && kit.byId[rg.id]) || rowGift(rg), g = {}, k;
    for (k in base) { if (Object.prototype.hasOwnProperty.call(base, k)) { g[k] = base[k]; } }
    var art = {}; for (k in (base.art || {})) { art[k] = base.art[k]; }
    if (rg.art && typeof rg.art === 'object') { for (k in rg.art) { if (rg.art[k]) { art[k] = rg.art[k]; } } }
    [128, 256, 512].forEach(function (n) {
      if (typeof rg['art_' + n] === 'string' && rg['art_' + n]) { art['png_' + n] = rg['art_' + n]; }
      if (typeof rg['art_png_' + n] === 'string' && rg['art_png_' + n]) { art['png_' + n] = rg['art_png_' + n]; }
      if (typeof rg['art_webp_' + n] === 'string' && rg['art_webp_' + n]) { art['webp_' + n] = rg['art_webp_' + n]; }
    });
    g.art = art;
    ['anim', 'duration_ms', 'where', 'tier_key', 'mechanic', 'name', 'slug'].forEach(function (f) { if (rg[f] !== undefined && rg[f] !== '') { g[f] = rg[f]; } });
    if (+rg.tier > 0) { g.tier = +rg.tier; }
    if (g.anim && (typeof g.anim !== 'object' || !g.anim.url)) { g.anim = (kit && kit.byId[rg.id] && kit.byId[rg.id].anim) || null; }
    return g;
  }
  /* the row's own gift (the catalog had none by that id): its 128 art is all there is */
  function rowGift(rg) {
    var a = rg.art || '', w = rg.art_webp || a;
    // the art files are named <slug>-<size>.<ext> (Gifts catalog): the 512 / 256 cuts sit beside the row's 128
    var sz = function (u, n) { return String(u).replace(/-128\.(png|webp)/, '-' + n + '.$1'); };
    return { id: rg.id, slug: rg.slug || ('g' + rg.id), name: rg.name || 'a gift', tier: +rg.tier || 1, gold: +rg.gold || 0, anim: null, mechanic: null,
             art: { png_128: a, webp_128: w, png_256: sz(a, 256), webp_256: sz(w, 256), png_512: sz(a, 512), webp_512: sz(w, 512) } };
  }

  /* ---------------- HEARTS: the live's rising hearts (livechat.js HPOOL / @keyframes lcHeart), pooled ---------------- */
  var HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 21.2l-1.45-1.32C5.4 15.24 2 12.16 2 8.4 2 5.32 4.42 2.9 7.5 2.9c1.74 0 3.41.81 4.5 2.09A6.02 6.02 0 0 1 16.5 2.9C19.58 2.9 22 5.32 22 8.4c0 3.76-3.4 6.84-8.55 11.48L12 21.2z"/></svg>';
  var HEART_COLORS = ['#ff4d6d', '#ff7aa2', '#ffd56a', '#ff5e3a', '#c86bff', '#ff8fab'];
  /* hearts for one 5 s bucket of n likes: n itself while small, then a gentle sqrt growth, capped */
  function heartCount(n) { n = +n || 0; return n <= 0 ? 0 : Math.min(HEART_CAP, n <= 4 ? n : Math.round(4 + 2.2 * Math.sqrt(n - 4))); }

  /* one style write only when the value changes (a paused replay that re-lays out touches nothing) */
  function css(e, p, val) {
    var c = e.__lrpCss || (e.__lrpCss = {});
    if (c[p] === val) { return; }
    c[p] = val;
    e.style.setProperty(p, val);
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) { e.className = cls; }
    if (text != null) { e.textContent = text; }
    return e;
  }
  /* THE MONOGRAM LETTER: the first CODE POINT, uppercased -- a mirror of NameText::initial() (lib/nametext.php) and app.js
     nameInitial(). charAt(0) / s[0] cut an emoji's UTF-16 surrogate pair in half ("💖heartless" -> a lone \uD83D, drawn
     as the replacement box: the iOS media-ring bug, 2026-10-17). Strips controls / zero-width / bidi marks like
     NameText::plain(); re-cuts after toUpperCase() (sharp s -> SS). Empty -> d (default '?'). */
  var FCP_CTRL = /[\u0000-\u001F\u007F-\u009F]+/g, FCP_ZERO = /[\u00AD\u200B-\u200F\u2028\u2029\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF]+/g;
  var FCP_ONE = /^(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\s\S])/;
  function firstCp(s, d) {
    var m = FCP_ONE.exec(String(s == null ? '' : s).replace(FCP_CTRL, ' ').replace(FCP_ZERO, '').trim());
    if (!m) { return d == null ? '?' : d; }
    var u = m[0].toUpperCase();
    return (FCP_ONE.exec(u) || [u])[0];
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* a picture as a background-image SPAN, never an <img>: the overlay lives inside the post's .media box, where the site's
     `.post .media img` rules (Ken Burns pan, full-box sizing, hover zoom) would grab any <img> */
  function okSrc(src) { return !!src && (/^(https?:)?\/\//.test(src) || /^\/[^\/]/.test(src)); }
  function pic(cls, src) {
    var s = el('span', cls + ' lrp-pic');
    if (okSrc(src)) { s.style.backgroundImage = 'url("' + String(src).replace(/["\\\n\r]/g, '') + '")'; }
    return s;
  }

  function fmtNum(n) {
    n = +n || 0;
    if (n >= 1e6) { return (Math.round(n / 1e5) / 10) + 'M'; }
    if (n >= 1e4) { return (Math.round(n / 1e3)) + 'K'; }
    return n.toLocaleString ? n.toLocaleString('en-US') : String(n);
  }
  /* the live bar's number format (livebattle.js fmt): 999, 1.2k, 3.4M */
  function fmtBar(n) { n = +n || 0; if (n < 1000) { return String(n); } var t = Math.round(n / 100) / 10; return (t >= 1000 ? (Math.round(t / 100) / 10) + 'M' : t + 'k').replace('.0', ''); }

  function clock(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(s / 60);
    s = s % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  /* BATTLE LEAGUES crest, byte-for-byte livebattle.js crest() (= LiveLeagues::crestSvg): gold-gradient field + the R mark, tier rims */
  var LG_ORDER = ['bronze', 'silver', 'gold', 'diamond', 'legend'];
  var LG_RIM = { bronze: ['#b8733a', '#e9a86a'], silver: ['#9aa3b0', '#e8edf3'], gold: ['#d4a020', '#f8d978'], diamond: ['#3fa6e0', '#c4f0ff'], legend: ['#f5c633', '#fff3b0'] };
  var LGC_PRE = 'lrpg' + Math.random().toString(36).slice(2, 7) + '_', LGC_N = 0;
  var LGC_STOPS = [[0, '#fdfac6'], [10, '#fdf8c1'], [24, '#fded9d'], [44, '#fdda63'], [50, '#f9c646'], [62, '#e2a128'], [76, '#cd8212'], [86, '#c47307'], [100, '#f79e02']]
    .map(function (x) { return '<stop offset="' + x[0] + '%" stop-color="' + x[1] + '"/>'; }).join('');
  function crest(t, size, label) {
    t = LG_RIM[t] ? t : 'bronze';
    var r = LG_RIM[t], w = size || 16, h = Math.round(w * 28 / 24), i, id = LGC_PRE + (++LGC_N);
    var s = '<svg class="lgc lgc-' + t + '" viewBox="0 0 24 28" width="' + w + '" height="' + h + '"' + (label ? ' role="img" aria-label="' + esc(label) + '"' : ' aria-hidden="true"') + ' focusable="false">' +
      '<defs><linearGradient id="' + id + '" gradientUnits="userSpaceOnUse" x1="2.6" y1="1.6" x2="21.4" y2="26.4">' + LGC_STOPS + '</linearGradient></defs>' +
      '<path d="M12 1.6 21.4 5v8c0 6.1-4 10.8-9.4 13.4C6.6 23.8 2.6 19.1 2.6 13V5z" fill="url(#' + id + ')" stroke="' + r[0] + '" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M12 3.4 19.6 6.2v6.8c0 5-3.2 8.9-7.6 11.1" fill="none" stroke="' + r[1] + '" stroke-width=".9" stroke-linecap="round" opacity=".75"/>' +
      '<image href="/assets/brand/rova-mark-crest-v1-128.png" x="4.4" y="5" width="15.2" height="15.2" preserveAspectRatio="xMidYMid meet"/>';
    if (t === 'diamond') { s += '<path d="M12 23.9l-1.9-1.6 1.9-1.6 1.9 1.6z" fill="' + r[1] + '" stroke="#121110" stroke-width=".5" stroke-linejoin="round"/>'; }
    else if (t === 'legend') { s += '<path d="M7.3 4.9 9 2.6l1.5 1.6L12 1.4l1.5 2.8L15 2.6l1.7 2.3z" fill="#f5c633" stroke="#121110" stroke-width=".5" stroke-linejoin="round"/><path class="lgc-shine" d="M5 6h3L4.6 20H3.2z" fill="#fff6c9" opacity="0"/>'; }
    else { var n = LG_ORDER.indexOf(t) + 1; for (i = 0; i < n; i++) { s += '<circle cx="' + (12 + (i - (n - 1) / 2) * 2.6) + '" cy="22.3" r=".95" fill="#121110"/>'; } }
    return s + '</svg>';
  }
  function lgOf(h) { return h && h.league && h.league.tier ? h.league : null; }

  /* ---------------- data (shared per post) ---------------- */

  function postData(pid) {
    var d = posts[pid];
    if (!d) { d = posts[pid] = { pid: pid, meta: null, rows: [], keys: {}, wins: {}, wdone: {}, dead: false, metaP: null, subs: [], scanTries: 0, scanT: 0,
                                 hasGift: false, likes: {}, hearts: [] }; }
    return d;
  }

  /* likes buckets [[t_ms, n], ...] (n hearts over the 5 s from t_ms) -> d.hearts = the sorted heart moments (ms on the replay clock) */
  function addLikes(d, ls) {
    if (!Array.isArray(ls) || !ls.length) { return; }
    var added = false;
    for (var i = 0; i < ls.length; i++) {
      var b = ls[i], t0 = b && +b[0], n = b && +b[1];
      if (!(t0 >= 0) || !(n > 0) || d.likes[t0]) { continue; }
      d.likes[t0] = n; added = true;
      var c = heartCount(n);
      for (var k = 0; k < c; k++) { d.hearts.push(Math.round(t0 + (k + 0.15 + Math.random() * 0.7) * 5000 / c)); }
    }
    if (added) { d.hearts.sort(function (a, b) { return a - b; }); }
  }
  /* the first index with arr[i] > t (arr sorted numbers) */
  function firstAfter(arr, t) {
    var lo = 0, hi = arr.length;
    while (lo < hi) { var mid = (lo + hi) >> 1; if (arr[mid] <= t) { lo = mid + 1; } else { hi = mid; } }
    return lo;
  }

  function url(pid, from, to, meta) {
    return '/post-replay?id=' + encodeURIComponent(pid) + '&from=' + Math.round(from) + '&to=' + Math.round(to) + (meta ? '&meta=1' : '');
  }

  function addRows(d, rows) {
    var added = false;
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      var k = (r.kind === 'gift' ? 'g' : 'c') + r.id;
      if (d.keys[k]) { continue; }
      d.keys[k] = 1;
      d.rows.push(r);
      added = true;
      if (r.kind === 'gift' && r.gift && chatOn) { d.hasGift = true; giftKit(!!r.gift.art_512); }   // warm the kit before the first gift's moment
    }
    if (added) { d.rows.sort(function (a, b) { return (a.t_ms - b.t_ms) || ((a.kind === 'gift') - (b.kind === 'gift')) || (a.id - b.id); }); }
  }

  function get(u) {
    return fetch(u, { credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.json().then(function (j) { j.__status = r.status; return j; }, function () { return { ok: false, __status: r.status }; }); });
  }

  /* the band is being measured (framing.band_scan 'pending': the server's worker lane, ~10-30 s once per replay): ask again */
  function clockSig(m) { var c = m && m.framing && m.framing.clock; return c ? (c.anchors || []).length + ':' + JSON.stringify(c.cuts || []) : ''; }
  function setMeta(d, m) {
    var was = d.meta;
    d.meta = m;
    if (was && clockSig(was) !== clockSig(m)) { d.rows = []; d.keys = {}; d.wins = {}; d.wdone = {}; d.likes = {}; d.hearts = []; d.gen = (d.gen || 0) + 1; d.metaP = Promise.resolve(true); }   // t_ms moved: read the rows again
  }
  function scanWait(d) {
    var f = d.meta && d.meta.framing;
    if (!f || (f.band_scan !== 'pending' && f.scan !== 'pending') || d.scanT || d.scanTries >= 10) { return; }
    d.scanT = setTimeout(function () {
      d.scanT = 0; d.scanTries++;
      get(url(d.pid, 0, 1, true)).then(function (j) {
        if (j && j.ok && j.replay) { setMeta(d, j.replay); notify(d); }
        scanWait(d);
      }, function () { scanWait(d); });
    }, 8000 + d.scanTries * 2000);
  }

  /* THE CLOCK MAP (framing.clock, 2026-10-12): every t_ms is already on the recording's clock; the battle CLOCK runs on the wall
     (battles[].wall) through the inverse map, so a stretched or cut recording still counts down true (LiveReplay::clkUnmap) */
  function wallAt(d, t) {
    var a = d.meta && d.meta.framing && d.meta.framing.clock && d.meta.framing.clock.anchors, n = a ? a.length : 0;
    if (!n) { return t; }
    if (t <= a[0][1]) { return a[0][0] + (t - a[0][1]); }
    if (t >= a[n - 1][1]) { return a[n - 1][0] + (t - a[n - 1][1]); }
    for (var i = n - 1; i > 0; i--) {
      if (a[i - 1][1] <= t && t <= a[i][1]) { var y0 = a[i - 1][1], y1 = a[i][1]; return a[i - 1][0] + (y1 > y0 ? (t - y0) / (y1 - y0) : 1) * (a[i][0] - a[i - 1][0]); }
    }
    return t;
  }

  /* one window [from, to): continues while the server says more (a capped busy window) */
  function fetchWindow(d, w, meta) {
    if (d.wins[w]) { return d.wins[w]; }
    var from = w * WIN, to = from + WIN, hops = 0, g0 = d.gen || 0;
    var p = new Promise(function (resolve) {
      var step = function (f, withMeta) {
        get(url(d.pid, f, to, withMeta)).then(function (j) {
          if (!j || !j.ok) {
            if (j && (j.__status === 404 || j.__status === 403)) { d.dead = true; notify(d); }
            else { delete d.wins[w]; d.retryAt = Date.now() + 10000; if (withMeta && !d.meta) { d.metaP = null; } }   // 429 / 5xx: again later
            resolve(false); return;
          }
          if (j.replay) { setMeta(d, j.replay); scanWait(d); g0 = d.gen || 0; }
          if ((d.gen || 0) !== g0) { resolve(false); return; }   // the clock moved under this read: its rows are on the old clock
          addRows(d, j.rows || []);
          addLikes(d, j.likes);
          notify(d);
          if (j.more && j.next_from_ms != null && j.next_from_ms > f && ++hops < 8) { step(j.next_from_ms, false); return; }
          d.wdone[w] = 1;
          notify(d);
          resolve(true);
        }, function () { delete d.wins[w]; d.retryAt = Date.now() + 10000; if (withMeta && !d.meta) { d.metaP = null; } resolve(false); });
      };
      step(from, meta);
    });
    d.wins[w] = p;
    return p;
  }

  function ensure(d, t) {
    if (d.dead || (d.retryAt && Date.now() < d.retryAt)) { return; }
    var w2 = Math.floor(Math.max(0, t) / WIN);
    if (!d.meta && !d.metaP) {
      d.metaP = fetchWindow(d, w2, true);
      return;   // the rest once the clock is known
    }
    if (!d.meta) { return; }
    fetchWindow(d, w2, false);
    if (w2 > 0 && t - w2 * WIN < 15000) { fetchWindow(d, w2 - 1, false); }   // early in a window: the lines just before it stay up
    if ((w2 + 1) * WIN - t < PREFETCH_MS && (w2 + 1) * WIN < (d.meta.duration_ms || Infinity) + WIN) { fetchWindow(d, w2 + 1, false); }
  }

  function notify(d) { for (var i = 0; i < d.subs.length; i++) { d.subs[i](); } }

  /* THE ROOM'S LIST NEVER TIMES OUT: the rows shown are the newest before the playhead, taken only from windows read CONTIGUOUSLY
     back from it (a window read earlier, further back, never puts an old line on top of a gap). floor = the first ms of that
     stretch; need = the window to read next to go further back (-1 = everything from 0 is read). The playhead's own window still
     loading counts as read (its lines arrive in a moment). */
  function history(d, t) {
    var w2 = Math.floor(Math.max(0, t) / WIN), k = w2 - 1;
    while (k >= 0 && d.wdone[k]) { k--; }
    return { floor: (k + 1) * WIN, need: k, w2: w2 };
  }

  /* the last index with rows[i].t_ms <= t, or -1 */
  function lastAt(rows, t) {
    var lo = 0, hi = rows.length - 1, ans = -1;
    while (lo <= hi) { var mid = (lo + hi) >> 1; if (rows[mid].t_ms <= t) { ans = mid; lo = mid + 1; } else { hi = mid - 1; } }
    return ans;
  }

  function inRuns(runs, t) {
    for (var i = 0; i < (runs || []).length; i++) { if (t >= runs[i][0] && t < runs[i][1]) { return runs[i]; } }
    return null;
  }

  /* ---------------- the chat toggle: ONE button in the player's own control bar ---------------- */

  var TOG_SVG_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.4A8 8 0 1 1 21 12z"/><path d="M8.5 10.5h7M8.5 13.5h4.5"/></svg>';
  var TOG_SVG_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.4A8 8 0 1 1 21 12z"/><path d="M4 4l16 16"/></svg>';
  function setTog(b) {
    b.setAttribute('aria-pressed', chatOn ? 'true' : 'false');
    b.setAttribute('aria-label', chatOn ? 'Hide replay chat' : 'Show replay chat');
    b.title = chatOn ? 'Replay chat: on (hide)' : 'Replay chat: off (show)';
    b.innerHTML = chatOn ? TOG_SVG_ON : TOG_SVG_OFF;
    b.classList.toggle('lrp-ctog-off', !chatOn);
  }
  function setChat(on) {
    chatOn = on;
    try { localStorage.setItem(LS_KEY, chatOn ? '1' : '0'); } catch (x) {}
    var all = document.querySelectorAll('.lrp');
    for (var i = 0; i < all.length; i++) { all[i].classList.toggle('lrp-off', !chatOn); }
    var togs = document.querySelectorAll('.lrp-ctog');
    for (var k = 0; k < togs.length; k++) { setTog(togs[k]); }
    overlays.slice().forEach(function (o) { o.chat(chatOn); });   // off = the gift stage + heart timers go too; on = from the next moment
  }
  var overlays = [];             // every attached overlay's api
  function makeTog() {
    var b = el('button', 'vc-btn lrp-ctog');
    b.type = 'button';
    setTog(b);
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); setChat(!chatOn); });
    ['pointerdown', 'touchstart', 'dblclick'].forEach(function (ev) { b.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true }); });
    return b;
  }

  /* ---------------- one overlay per <video> ---------------- */

  function host(v) {
    var h = v.parentElement;
    if (!h) { return null; }
    if (getComputedStyle(h).position === 'static') { h.classList.add('lrp-host'); }
    return h;
  }

  function attach(v) {
    var pid = v.getAttribute('data-lreplay');
    if (!pid || !/^\d+$/.test(pid)) { return; }
    var cur = views ? views.get(v) : v.__lrp;
    if (cur) { cur.kick(); return; }
    var d = postData(pid);
    if (d.dead) { return; }
    ensureCss();
    var h = host(v);
    if (!h) { return; }
    var rec = v.getAttribute('data-lrec') || '';
    var root = el('div', 'lrp' + (chatOn ? '' : ' lrp-off') + (reduce ? ' lrp-rm' : ''));
    var list = el('div', 'lrp-list');
    list.setAttribute('aria-live', 'off');
    root.appendChild(list);
    var tog = makeTog();
    var shown = {};              // key -> element
    var pending = false, lastLayout = 0, lastT = -1, seekMode = false, alive = true;
    var inPf = !!(h.closest && h.closest('.pfeed'));
    var st = null;               // the battle stage (built on first need)
    var mode = 'solo', modeKey = '';
    var geo = null;              // the battle overlay's geometry (layer px; the layer covers the picture)
    var pills = null, pillsKey = '';
    var gd = null, gdP = null, gTok = 0, fxT = -1, kitRef = null;            // the gift stage (gifts.js display door), its build, the last ms fed
    var hearts = null, HP = [], HP_MAX = 36, hb = null, hT = -1, hTimers = [];
    var frozen = false, visible = true, io = null, waapi = [];
    var chBox = null, chPrev = null, chNext = null, chK = '', chIx = -2, chFit = false;
    var dbgN = { gifts: 0, giftsSkipped: 0, stages: 0, hearts: 0, heartSkips: 0, heartTimers: 0, freezes: 0 };
    if (inPf) { root.classList.add('lrp-pf'); }

    /* the control bar this video answers to: its own (.media > .vctrl) or the carousel's pinned one */
    function ctrlRow() {
      var r = h.querySelector(':scope > .vctrl .vc-row');
      if (!r) {   // a carousel in the viewer: ONE pinned bar, owned by the current slide (app.js ensurePinnedBar)
        var car = h.closest && h.closest('.carousel');
        var pin = car && car.querySelector(':scope > .pf-cbar .vctrl .vc-row');
        var cur = car && car.__cidx ? car.querySelectorAll('.cslide')[car.__cidx()] : null;
        if (pin && cur === h) { r = pin; }
      }
      return r;
    }
    function placeTog() {
      var row = ctrlRow();
      if (!row) { if (tog.parentNode) { tog.parentNode.removeChild(tog); } return; }
      if (tog.parentNode === row) { return; }
      var at = row.querySelector('.vc-time') || row.querySelector('.vc-flex');
      row.insertBefore(tog, at || null);
    }

    /* geometry: the layer covers the PICTURE (a letterboxed clip -- a portrait replay on a desktop viewer -- keeps the chat on
       the video, not out in the black bars); the list sits above the control bar, and in the immersive viewer above the
       caption block too */
    function picRect(box) {
      var vr = v.getBoundingClientRect();
      var x = vr.left, y = vr.top, w = vr.width, hh = vr.height;
      var fit = '';
      try { fit = getComputedStyle(v).objectFit; } catch (e) {}
      var vw = v.videoWidth || +v.getAttribute('width') || 0, vh = v.videoHeight || +v.getAttribute('height') || 0;
      if (vw > 0 && vh > 0 && w > 0 && hh > 0 && (fit === 'contain' || fit === 'scale-down')) {
        var s = Math.min(w / vw, hh / vh);
        var pw = vw * s, ph = vh * s;
        x += (w - pw) / 2; y += (hh - ph) / 2; w = pw; hh = ph;
      } else if (vw > 0 && vh > 0 && w > 0 && hh > 0 && fit === 'cover') {
        var c = Math.max(w / vw, hh / vh);
        var cw = vw * c, ch = vh * c;
        return { left: Math.max(x, box.left), top: Math.max(y, box.top), right: Math.min(x + w, box.right), bottom: Math.min(y + hh, box.bottom), full: { x: x + (w - cw) / 2, y: y + (hh - ch) / 2, w: cw, h: ch } };
      }
      var l = Math.max(x, box.left), t = Math.max(y, box.top), r = Math.min(x + w, box.right), b = Math.min(y + hh, box.bottom);
      if (r - l < 120 || b - t < 120) { return { left: box.left, top: box.top, right: box.right, bottom: box.bottom, full: { x: x, y: y, w: w, h: hh } }; }
      return { left: l, top: t, right: r, bottom: b, full: { x: x, y: y, w: w, h: hh } };
    }

    /* the lowest y (viewport px) the chat may reach: above the control bar and, in the viewer, above the caption block */
    function bottomLimit(box, pr) {
      var limit = pr.bottom - 12;
      var vc = h.querySelector(':scope > .vctrl');
      if (vc) { var r = vc.getBoundingClientRect(); if (r.height && r.top < pr.bottom) { limit = Math.min(limit, r.top - 8); } }
      if (inPf) {
        var pm = h.parentElement;
        if (pm) {
          for (var i = 0; i < pm.children.length; i++) {
            var c = pm.children[i];
            if (c === h || c.classList.contains('pmenu')) { continue; }
            var rc = c.getBoundingClientRect();
            if (!rc.height || rc.top < pr.top + (pr.bottom - pr.top) * 0.35 || rc.top > pr.bottom) { continue; }
            if (rc.right <= pr.left || rc.left > pr.left + (pr.right - pr.left) * 0.6) { continue; }   // beside the picture / a right-hand rail: no push
            limit = Math.min(limit, rc.top - 8);
          }
        }
      }
      return limit;
    }

    /* the chrome along the bottom (kind 'bot'): the player's control bar and, in the viewer, the caption block -- viewport rects. A top-right
       pill that would land on one (a tile whose top is behind the controls) is hidden: better no name than a name on the buttons */
    function bottomObs(pr) {
      var out = [], vc = h.querySelector(':scope > .vctrl');
      if (vc) { var r = vc.getBoundingClientRect(); if (r.height && r.top < pr.bottom) { out.push({ k: 'bot', l: r.left, r: r.right, t: r.top, b: r.bottom }); } }
      var pm = inPf ? h.parentElement : null;
      if (pm) {
        for (var i = 0; i < pm.children.length; i++) {
          var c = pm.children[i];
          if (c === h || c.classList.contains('pmenu')) { continue; }
          var rc = c.getBoundingClientRect();
          if (rc.height && rc.width && rc.bottom > pr.top && rc.top < pr.bottom) { out.push({ k: 'bot', l: rc.left, r: rc.right, t: rc.top, b: rc.bottom }); }
        }
      }
      return out;
    }

    /* what may sit over a tile's TOP-RIGHT corner (the pills' obstacles since 2026-10-14) -- viewport rects:
       kind 'top'  = the viewer's header row (.pfeed-bar: back / @handle / ⋯; reserved at >= 58 px even while it fades on idle, so a pill
                     never jumps) and any small badge/button inside the media box -> a pill under one DROPS just below it;
       kind 'side' = the viewer's hands-free rail (.pf-hf-rep / -dock / -rate, right edge) while the chrome is AWAKE (not .pfeed-idle,
                     a button not [hidden]) -> a pill crossing it STEPS LEFT of it and the name shortens with an ellipsis (Rob 2026-10-14:
                     "Dj Mike…"), at least ~4 characters, else the seat number goes, else the pill hides; the chrome resting brings the
                     full name back at the corner (a MutationObserver on the .pfeed class re-lays the pills out) */
    function topObs(box, pr) {
      var out = [], pf = inPf && h.closest ? h.closest('.pfeed') : null;
      if (pf) {
        var fr = pf.getBoundingClientRect();
        var bar = pf.querySelector('.pfeed-bar'), bb = fr.top + 58;
        if (bar) { var br = bar.getBoundingClientRect(); if (br.height) { bb = Math.max(bb, br.bottom); } }
        out.push({ k: 'top', l: fr.left, r: fr.right, t: fr.top, b: bb });
        var rail = null, hf = pf.classList.contains('pfeed-idle') ? [] : pf.querySelectorAll('.pf-hf-rep, .pf-hf-dock, .pf-hf-rate');
        for (var i = 0; i < hf.length; i++) {
          if (hf[i].hidden) { continue; }
          var hr = hf[i].getBoundingClientRect();
          if (!hr.width || !hr.height) { continue; }
          try { if (getComputedStyle(hf[i]).display === 'none') { continue; } } catch (e) {}
          rail = rail ? { k: 'side', l: Math.min(rail.l, hr.left), r: Math.max(rail.r, hr.right), t: Math.min(rail.t, hr.top), b: Math.max(rail.b, hr.bottom) }
                      : { k: 'side', l: hr.left, r: hr.right, t: hr.top, b: hr.bottom };
        }
        if (rail) { out.push(rail); }
      }
      for (var j = 0; j < h.children.length; j++) {
        var c = h.children[j];
        if (c === v || c === root || c.classList.contains('vctrl') || c.tagName === 'VIDEO' || c.tagName === 'SOURCE') { continue; }
        var rc = c.getBoundingClientRect();
        if (!rc.width || !rc.height || rc.width > box.width * 0.6 || rc.height > box.height * 0.4) { continue; }   // posters / full-box layers: not chrome
        if (rc.top > pr.top + (pr.bottom - pr.top) * 0.25 || rc.bottom < pr.top) { continue; }                    // only chrome on the top edge (not a centred play disc)
        try { var cs = getComputedStyle(c); if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) { continue; } } catch (e) {}
        out.push({ k: 'top', l: rc.left, r: rc.right, t: rc.top, b: rc.bottom });
      }
      return out;
    }

    /* THE IDLE DROP (Rob 2026-10-15: "when the chrome disappears ... smoothly animate the chat down ... so it doesn't leave all that
       empty space"). The list sits --lrp-bottom above the picture's bottom so it clears the caption / roller / control bar; when the
       viewer rests (.pfeed-idle fades all of that) livereplay.css slides the list DOWN by --lrp-drop with a transform, on the chrome
       fade's own .35s ease, and back up when it wakes. Measured here, in the same pass as --lrp-bottom (layout: <= 1/s, on resize and
       on a re-parent), never per frame and never on the class flip itself: the faded chrome keeps its boxes (opacity / visibility
       only), so the awake geometry reads the same either way. Target = the last row LRP_IDLE_GUT above the picture's bottom, and
       above the home indicator where the picture runs under it (safe-area probe). Never negative: the list never climbs on idle. */
    var sab = null;
    function idleDrop(picBottom, bottom) {
      if (!inPf) { return 0; }
      if (!sab) {
        sab = el('div', 'lrp-sab');
        sab.setAttribute('aria-hidden', 'true');
        root.appendChild(sab);
      }
      var vb = window.innerHeight || document.documentElement.clientHeight || picBottom;
      var gut = Math.max(LRP_IDLE_GUT, Math.round((sab.offsetHeight || 0) + LRP_IDLE_GUT - Math.max(0, vb - picBottom)));
      return Math.max(0, bottom - gut);
    }

    function layout() {
      var box = h.getBoundingClientRect();
      hb = null;   // the hearts box is measured again on the next heart
      if (!box.height) { return; }
      var pr = (rt && (rt.n > 1 || rt.bm) && rtRegion(box, rt.n, rt.bm)) || picRect(box);   // THE BUBBLE STAGE: many people / a battle = the window, not the frame
      var underY = null;
      css(root, 'left', Math.round(pr.left - box.left) + 'px');
      css(root, 'top', Math.round(pr.top - box.top) + 'px');
      css(root, 'width', Math.round(pr.right - pr.left) + 'px');
      css(root, 'height', Math.round(pr.bottom - pr.top) + 'px');
      var limit = bottomLimit(box, pr);
      var top = inPf ? Math.max(10, Math.round(box.top + 58 - pr.top)) : 10;
      var bottom = Math.max(12, Math.round(pr.bottom - limit));
      css(root, '--lrp-bottom', bottom + 'px');
      css(root, '--lrp-drop', idleDrop(pr.bottom, bottom) + 'px');
      css(root, '--lrp-top', top + 'px');
      var room = Math.max(60, Math.round((pr.bottom - pr.top) - bottom - top - 44));
      if (mode === 'battle') {   // the battle UI on the picture; the chat list starts under the score bar
        geo = { box: box, pr: pr, top: top, bottom: bottom };
        var under = placeStage();
        underY = under;
        if (under != null) { room = Math.max(0, Math.round((pr.bottom - pr.top) - bottom - under - 10)); }
      }
      if (pills) {
        // a pill over the chat column caps the list's top just under it (the rows never climb into a name)
        var capY = placePills(box, pr, topObs(box, pr).concat(bottomObs(pr)));
        if (capY != null) { room = Math.max(0, Math.min(room, Math.round((pr.bottom - pr.top) - bottom - capY - 6))); }
      }
      css(root, '--lrp-room', room + 'px');
      if (rt) { rtResize(underY); }
    }

    function partStart() {
      var m = d.meta;
      if (!m || !m.parts || !m.parts.length) { return 0; }
      if (rec) { for (var i = 0; i < m.parts.length; i++) { if (m.parts[i].uid === rec) { return m.parts[i].start_ms || 0; } } }
      return 0;
    }

    function now() { return partStart() + (v.currentTime || 0) * 1000; }
    function partDur() {
      if (isFinite(v.duration) && v.duration > 0) { return v.duration * 1000; }
      var m = d.meta || {}, ps = m.parts || [];
      if (rec) { for (var i = 0; i < ps.length; i++) { if (ps[i].uid === rec && ps[i].dur_ms) { return ps[i].dur_ms; } } }
      return ps.length === 1 && ps[0].dur_ms ? ps[0].dur_ms : (m.duration_ms || 0);
    }

    /* ---------- GIFTS: each gift row plays the live's own moment (gifts.js Player, display-only) at its time ---------- */
    function dropGifts() { gTok++; gdP = null; if (gd) { gd.destroy(); gd = null; } }
    function giftStage() {
      if (gd) { return Promise.resolve(gd); }
      if (gdP) { return gdP; }
      var tok = gTok;
      gdP = giftKit().then(function (k) {
        if (!k || !alive || !chatOn || tok !== gTok) { if (tok === gTok) { gdP = null; } return null; }
        if (gd) { return gd; }
        var s = el('div', 'gstage gs-watch gs-replay');
        root.insertBefore(s, hearts || null);   // over the chat (the live's z order), under the hearts
        kitRef = k;
        gd = window.__rovaGiftDisplay(s, { catalog: k.catalog, broadcaster: (d.meta && d.meta.host) || null });
        dbgN.stages++;
        if (frozen) { gd.pause(true); }
        return gd;
      });
      return gdP;
    }
    function playGift(r) {
      var tok = gTok;
      giftStage().then(function (g) {
        if (!g || tok !== gTok || frozen || !alive) { dbgN.giftsSkipped++; return; }
        if (now() - r.t_ms > FX_WIN_MS + 600) { dbgN.giftsSkipped++; return; }   // the kit came too late for this one: never a stale burst
        var rg = r.gift, host = (d.meta && d.meta.host) || null, u = r.user || {};
        g.addGift(giftFor(rg, kitRef));   // row fields > catalog > the row's 128 art
        var snd = r.anonymous || !(+u.id > 0) ? { id: 0, username: '', display_name: 'A Patron', avatar: '' }
          : { id: +u.id, username: u.username || '', display_name: u.display_name || u.short_name || u.username || '', avatar: u.avatar || '', gifter: u.gifter || null };
        g.show({ id: r.id, gift: { id: rg.id }, sender: snd, receiver: r.receiver || host, qty: +r.qty || 1, combo: +r.combo || +r.qty || 1, anonymous: !!r.anonymous });
        dbgN.gifts++;
      });
    }
    /* the gift rows in (fxT, t], within FX_WIN_MS of the playhead; a jump (seek / loop / backwards) = a fresh stage, nothing skipped over */
    function feedGifts(t, jump) {
      if (!d.hasGift) { fxT = t - FX_WIN_MS; return; }   // rows still on their way: the last second stays playable
      if (!chatOn || frozen) { fxT = t; return; }
      if (jump || fxT < 0 || t < fxT) { if (gd || gdP) { dropGifts(); } fxT = t - FX_WIN_MS; }
      var rows = d.rows;
      for (var i = lastAt(rows, fxT) + 1; i < rows.length && rows[i].t_ms <= t; i++) {
        var r = rows[i];
        if (r.kind === 'gift' && r.gift && t - r.t_ms <= FX_WIN_MS) { playGift(r); }
      }
      fxT = t;
    }

    /* ---------- HEARTS: the live's rising hearts (livechat.js spawnHeart, ambient path), from a pool, timed to the likes buckets ---------- */
    function heartNode() {
      if (!hearts) { hearts = el('div', 'lrp-hearts'); hearts.setAttribute('aria-hidden', 'true'); root.appendChild(hearts); }
      var n = HP.length, i, p, start = (Math.random() * (n || 1)) | 0;
      for (i = 0; i < n; i++) { p = HP[(start + i) % n]; if (!p.a) { return p; } }   // a random free one = a random colour
      if (n >= HP_MAX) { return null; }
      p = { el: el('span', 'lrp-heart'), a: null };
      p.el.innerHTML = HEART_SVG;
      p.el.style.color = HEART_COLORS[n % HEART_COLORS.length];
      hearts.appendChild(p.el); HP.push(p);
      return p;
    }
    function tf(x, y, s, r) { return 'translate(' + x + 'px,' + y + 'px) scale(' + s.toFixed(3) + ') rotate(' + r.toFixed(1) + 'deg)'; }
    function spawnHeart() {
      if (!alive || frozen || reduce || !chatOn) { return; }
      var p = heartNode();
      if (!p) { dbgN.heartSkips++; return; }
      if (typeof p.el.animate !== 'function') { return; }   // no WAAPI (very old engines): no replay hearts
      if (!hb) { hb = { w: hearts.clientWidth || 70, h: hearts.clientHeight || 300 }; }
      // = livechat.js @keyframes lcHeart: rises from the box's bottom-right (the 30px heart = the 40px node at .75)
      var dx = (Math.random() * 2 - 1) * 34, rot = (Math.random() * 2 - 1) * 22, s = 0.8 + Math.random() * 0.55;
      var bx = Math.round(hb.w - 51), by = Math.round(hb.h - 35), F = 'cubic-bezier(.25,.6,.35,1)', q = 0.75;
      var a = p.el.animate([{ offset: 0, opacity: 0, transform: tf(bx, by, 0.4 * q, 0), easing: F },
                            { offset: 0.12, opacity: 1, transform: tf(bx, by - 18, s * q, rot * 0.3), easing: F },
                            { offset: 0.7, opacity: 0.9, transform: tf(bx + dx * 0.9, by - 236, s * q * 0.865, rot * 0.93), easing: 'ease-out' },
                            { offset: 1, opacity: 0, transform: tf(bx + dx, by - 260, s * q * 0.85, rot) }],
                           { duration: 1500 + Math.random() * 700 | 0, fill: 'none' });
      p.a = a;
      a.onfinish = a.oncancel = function () { if (p.a === a) { p.a = null; } };
      dbgN.hearts++;
    }
    function clearHearts() { for (var i = 0; i < hTimers.length; i++) { clearTimeout(hTimers[i]); } hTimers = []; }
    /* heart moments in (hT, t + HEART_LEAD] get a timer each; nothing older than FX_WIN_MS floats (a seek never replays a swarm) */
    function feedHearts(t, jump) {
      var H = d.hearts;
      if (!H.length || !chatOn || frozen || reduce) { hT = t; return; }
      if (jump || hT < 0 || t < hT - HEART_LEAD - 60) { clearHearts(); hT = t - FX_WIN_MS; }
      var to = t + HEART_LEAD, rate = v.playbackRate > 0 ? v.playbackRate : 1;
      for (var i = firstAfter(H, hT); i < H.length && H[i] <= to; i++) {
        if (t - H[i] > FX_WIN_MS) { continue; }
        hTimers.push(setTimeout(spawnHeart, Math.max(0, Math.round((H[i] - t) / rate))));
        dbgN.heartTimers++;
      }
      if (hTimers.length > 64) { hTimers = hTimers.slice(-32); }   // fired ones need no cancel; the last LEAD's worth always stays
      hT = to;
    }

    /* ---------- PAUSED / ENDED / OFFSCREEN = FROZEN: no frames, no timers ---------- */
    function freeze(on) {
      on = !!on;
      if (on === frozen) { return; }
      frozen = on;
      root.classList.toggle('lrp-paused', on);   // every CSS animation in the layer (the gift moments, the pills' bob)
      if (on) {
        dbgN.freezes++;
        clearHearts(); hT = Math.min(hT, now());   // the next moments are timed again on resume
        waapi = [];
        try {
          if (root.getAnimations) {
            root.getAnimations({ subtree: true }).forEach(function (a) {
              if (a.playState === 'running' && !a.animationName && !a.transitionProperty) { a.pause(); waapi.push(a); }   // WAAPI only (hearts, count pops)
            });
          }
        } catch (e) {}
      } else {
        waapi.forEach(function (a) { try { if (a.playState === 'paused') { a.play(); } } catch (e) {} });
        waapi = [];
      }
      if (gd) { gd.pause(on); }
    }
    function syncFreeze() { if (alive) { freeze(v.paused || v.ended || !visible || document.hidden); } }

    /* ---------- CHAPTERS: marks on the seek bar + previous / next in the control row ---------- */
    var CH_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 5v14"/><path d="M18 6l-8 6 8 6z" fill="currentColor"/></svg>';
    var CH_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 5v14"/><path d="M6 6l8 6-8 6z" fill="currentColor"/></svg>';
    function chList() {
      var cs = (d.meta && d.meta.chapters) || [], ps = partStart(), dur = partDur(), out = [];
      for (var i = 0; i < cs.length; i++) { var c = cs[i]; if (c && c.t_ms >= ps && (!dur || c.t_ms < ps + dur)) { out.push(c); } }
      out.sort(function (a, b) { return a.t_ms - b.t_ms; });
      return out;
    }
    function chName(c) { return c ? (c.label || ({ battle: 'Battle', cohost: 'Co-host', call: 'Call', room: 'Open Room', cut: 'Skipped', paused: 'Video paused', resume: 'Video back' }[c.kind]) || 'Chapter') : ''; }
    function chGo(dir) {
      var list = chList(), t = now(), ps = partStart(), target = null, i;
      if (dir > 0) { for (i = 0; i < list.length; i++) { if (list[i].t_ms > t + 500) { target = list[i].t_ms; break; } } }
      else { for (i = list.length - 1; i >= 0; i--) { if (list[i].t_ms < t - 2500) { target = list[i].t_ms; break; } } if (target == null) { target = ps; } }
      if (target == null) { return; }
      try { v.currentTime = Math.max(0, (target - ps) / 1000); } catch (e) {}
      kick();
    }
    function chBtn(cls, svg, dir) {
      var b = el('button', 'vc-btn lrp-chb ' + cls);
      b.type = 'button'; b.innerHTML = svg;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); chGo(dir); });
      ['pointerdown', 'touchstart', 'dblclick'].forEach(function (ev) { b.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true }); });
      return b;
    }
    function dropChapters() {
      if (chBox && chBox.parentNode) { chBox.parentNode.removeChild(chBox); }
      [chPrev, chNext].forEach(function (b) { if (b && b.parentNode) { b.parentNode.removeChild(b); } });
      chBox = null; chK = ''; chIx = -2;
    }
    function placeChapters(t) {
      var row = ctrlRow(), list = row ? chList() : [], dur = partDur(), ps = partStart();
      var seek = row && row.parentElement ? row.parentElement.querySelector(':scope > .vc-seek') : null;
      if (!list.length || !seek || !(dur > 0)) { if (chK || chPrev && chPrev.parentNode) { dropChapters(); } return; }
      var k = list.map(function (c) { return c.t_ms + c.kind; }).join(',') + '|' + Math.round(dur);
      if (k !== chK || !chBox || chBox.parentNode !== seek) {
        if (chBox && chBox.parentNode) { chBox.parentNode.removeChild(chBox); }
        chK = k; chIx = -2;
        chBox = el('span', 'lrp-chm-box'); chBox.setAttribute('aria-hidden', 'true');
        list.forEach(function (c) {
          var m = el('i', 'lrp-chm lrp-chm-' + String(c.kind || 'x').replace(/[^a-z]/g, ''));
          m.style.left = Math.max(0, Math.min(100, (c.t_ms - ps) / dur * 100)).toFixed(3) + '%';
          chBox.appendChild(m);
        });
        seek.appendChild(chBox);
      }
      if (!chPrev) { chPrev = chBtn('lrp-chp', CH_PREV, -1); chNext = chBtn('lrp-chn', CH_NEXT, 1); }
      if (chPrev.parentNode !== row || chNext.parentNode !== row) {
        var at = tog.parentNode === row ? tog : (row.querySelector('.vc-time') || row.querySelector('.vc-flex'));
        row.insertBefore(chPrev, at || null); row.insertBefore(chNext, at || null);
        chFit = false;
      }
      /* a full row (the viewer's at phone width carries the post's own actions too) never overflows for them: the buttons step aside,
         the marks stay. Measured when they go in and after a resize (layout), never per frame. */
      if (!chFit) {
        chFit = true;
        var tight = function (on) { chPrev.classList.toggle('lrp-chb-off', on); chNext.classList.toggle('lrp-chb-off', on); };
        tight(false);
        if (row.scrollWidth > row.clientWidth + 1) { tight(true); }
      }
      // the labels say where each button goes (written only when the chapter under the playhead changes)
      var ix = -1, i;
      for (i = 0; i < list.length; i++) { if (list[i].t_ms <= t + 500) { ix = i; } }
      if (ix !== chIx) {
        chIx = ix;
        var nx = list[ix + 1] || null, pv = null;
        for (i = list.length - 1; i >= 0; i--) { if (list[i].t_ms < t - 2500) { pv = list[i]; break; } }
        chNext.disabled = !nx;
        chNext.setAttribute('aria-label', nx ? 'Next chapter: ' + chName(nx) : 'No next chapter'); chNext.title = nx ? 'Next: ' + chName(nx) : 'No next chapter';
        chPrev.setAttribute('aria-label', pv ? 'Previous chapter: ' + chName(pv) : 'Back to the start'); chPrev.title = pv ? 'Previous: ' + chName(pv) : 'Back to the start';
      }
    }

    function rowEl(r) {
      var kind = r.kind === 'gift' ? 'gift' : (r.kind === 'join' ? 'join' : (r.kind === 'system' ? (r.event === 'follow' ? 'follow' : r.event === 'share' ? 'share' : 'system') : 'chat'));   // db/0293: share rows
      var row = el('div', 'lrp-row lrp-' + kind);
      var u = r.user;
      if (u && kind !== 'system') {
        var av;
        if (u.avatar && !r.anonymous) { av = pic('lrp-av', u.avatar); }
        else { av = el('span', 'lrp-av lrp-av-mono', r.anonymous ? 'P' : firstCp(u.short_name || u.display_name)); if (r.anonymous) { av.className += ' lrp-av-crest'; } }
        if (kind === 'join' || kind === 'follow' || kind === 'share') { av.className += ' lrp-av-s'; }
        row.appendChild(av);
      }
      var txt = el('div', 'lrp-txt');
      if (kind === 'chat' || kind === 'gift') {
        var nm = el('span', 'lrp-nm', (u && (u.short_name || u.display_name)) || '');
        txt.appendChild(nm);
        if (u && u.is_broadcaster) { txt.appendChild(el('span', 'lrp-host', 'Host')); }
        txt.appendChild(document.createTextNode(' '));
        txt.appendChild(el('span', 'lrp-b', r.body || ''));
      } else if (kind === 'join' || kind === 'follow' || kind === 'share') {
        txt.appendChild(el('span', 'lrp-b', r.body || ''));
      } else {
        txt.textContent = r.body || '';
      }
      row.appendChild(txt);
      if (kind === 'gift' && r.gift && (r.gift.art_webp || r.gift.art)) {
        var ga = pic('lrp-gart', r.gift.art_webp || r.gift.art);
        ga.setAttribute('role', 'img');
        ga.setAttribute('aria-label', r.gift.name || 'gift');
        row.appendChild(ga);
      }
      return row;
    }

    /* ---------- which phase is the picture in? ---------- */
    function framing() { return (d.meta && d.meta.framing) || null; }
    /* LIVE-TO-LIVE CO-HOST (db/0271): meta.links [{id, from_ms, to_ms, left, right}] = the stretches this live was CONNECTED with another
       host: the band on top like a battle with no bar, clock or VS, both names + the "Co-host" label (the live room's linked view) */
    function linkAt(t) {
      var ls = (d.meta && d.meta.links) || [];
      for (var i = 0; i < ls.length; i++) { if (t >= ls[i].from_ms && t < ls[i].to_ms) { return ls[i]; } }
      return null;
    }
    function battleAt(t) {
      var bs = (d.meta && d.meta.battles) || [];
      var f = framing(), lk = linkAt(t);
      for (var i = 0; i < bs.length; i++) {
        var b = bs[i];
        var resEnd = Math.max(b.result_end_ms || 0, (b.result_ms || b.end_ms) + TAIL_MS);
        if (lk) { resEnd = Math.max(b.result_end_ms || 0, b.result_ms || b.end_ms); }   // inside a link the band goes on: the link view, not a tail
        if (t >= b.intro_ms && t < resEnd) { return { b: b, tail: false }; }
        // THE BAND'S TAIL: the host's app can keep compositing the band after the after-party (#2413: ~25 s); the picture is still
        // two halves in the middle of a dark frame, so keep the band on top (no bar, no clock) until the band leaves the picture
        var run = f && f.band_scan === 'done' ? inRuns(f.band_runs, t) : null;
        if (!lk && run && t >= resEnd && run[0] < resEnd) { return { b: b, tail: true }; }
      }
      if (lk) { return { b: { id: 'L' + lk.id, link: true, left: lk.left || {}, right: lk.right || {}, intro_ms: lk.from_ms, start_ms: lk.from_ms, end_ms: lk.to_ms,
                              result_ms: lk.to_ms, result_end_ms: lk.to_ms, duration_s: 0, scores: [] }, tail: true, link: true }; }
      return null;
    }
    function bandAt(t) {
      var f = framing();
      if (!f || !f.band) { return false; }
      if (f.frame && f.frame.w > f.frame.h) { return true; }   // landscape: the whole picture is the band
      if (f.band_scan !== 'done') { return false; }            // not measured (yet): never assume a band that may not be there
      return !!inRuns(f.band_runs, t);
    }
    /* THE RECORDING'S OWN SEAM (2026-10-15): where in the picture the host's phone drew the two battle tiles, as FRACTIONS of the frame
       {x0, y0, x1, y1 = the band, seam = the x between the tiles, ox0 / ox1 = the opponent's tile}. Source: the recorded layout at t
       (framing.layouts, db/0270: the 'band' tiles the host's app reported), believed while the band is not measured yet and, once it
       is, only inside a measured band run (an app that reports 'band' but sends its camera alone gets no seam); else (older lives with
       no recorded layout) framing.band inside a measured run, split in the middle. null = no band in the picture: no seam */
    function seamAt(t) {
      var f = framing();
      if (!f) { return null; }
      var ls = f.layouts || [], lay = null;
      for (var i = 0; i < ls.length; i++) { if (ls[i].t_ms <= t) { lay = ls[i]; } else { break; } }
      var measured = f.band_scan === 'done';
      var land = !!(f.frame && f.frame.w > f.frame.h);
      if (lay && lay.mode === 'band' && (lay.tiles || []).length >= 2 && lay.w > 0 && lay.h > 0 && (!measured || land || inRuns(f.band_runs, t))) {
        var ts = lay.tiles.slice(0, 2).sort(function (a, b) { return a.x - b.x; });
        var hostId = +((d.meta && d.meta.host && d.meta.host.id) || 0);
        var opp = hostId && ts[0].user && +ts[0].user.id === hostId ? ts[1] : (hostId && ts[1].user && +ts[1].user.id === hostId ? ts[0] : ts[1]);
        var x0 = Math.min(ts[0].x, ts[1].x), y0 = Math.min(ts[0].y, ts[1].y);
        var x1 = Math.max(ts[0].x + ts[0].w, ts[1].x + ts[1].w), y1 = Math.max(ts[0].y + ts[0].h, ts[1].y + ts[1].h);
        return { x0: x0 / lay.w, y0: y0 / lay.h, x1: x1 / lay.w, y1: y1 / lay.h, seam: (ts[0].x + ts[0].w + ts[1].x) / 2 / lay.w,
                 ox0: opp.x / lay.w, ox1: (opp.x + opp.w) / lay.w };
      }
      if (bandAt(t)) {
        var fw = (f.frame && f.frame.w) || 0, fh = (f.frame && f.frame.h) || 0, bd = f.band;
        if (!(fw > 0 && fh > 0 && bd && bd.w > 0 && bd.h > 0)) { return null; }
        var sx = (bd.x + bd.w / 2) / fw;
        return { x0: bd.x / fw, y0: bd.y / fh, x1: (bd.x + bd.w) / fw, y1: (bd.y + bd.h) / fh, seam: sx, ox0: sx, ox1: (bd.x + bd.w) / fw };
      }
      return null;
    }
    function callAt(t) {
      var f = framing(), cs = (f && f.calls) || [];
      for (var i = 0; i < cs.length; i++) { if (t >= cs[i].from_ms && t < cs[i].to_ms) { return cs[i]; } }
      return null;
    }

    function scoreAt(b, t) {
      var s = b.scores || [];
      var lo = 0, hi = s.length - 1, ans = -1;
      while (lo <= hi) { var mid = (lo + hi) >> 1; if (s[mid][0] <= t) { ans = mid; lo = mid + 1; } else { hi = mid - 1; } }
      return ans < 0 ? [0, 0] : [s[ans][1], s[ans][2]];
    }

    function avatarOf(u, cls) {
      if (u && u.avatar) { return pic(cls, u.avatar); }
      return el('span', cls + ' lrp-av-mono', firstCp(u && (u.display_name || u.username)));
    }

    /* ---------- THE BATTLE OVERLAY (2026-10-15): the battle UI ON the host's recording, never a split stage ----------
       The layer covers the PICTURE (layout(), as for a solo replay); the pieces keep the live room's look (livebattle.css values,
       mirrored in livereplay.css). Where the recording is a band composite (seamAt), .lrp-band is the band's rect on the picture:
       the VS disc on the recording's own seam, the opponent's chip on the opponent's tile, the 3-2-1 over it, the clock pill /
       result strip on the band's edge next to the score bar. No band in the picture: the score bar along the picture's top and
       the clock / result under it, the 3-2-1 over the picture -- no VS, no chip, no tile that is not in the recording. */
    function buildStage() {
      var s = {};
      s.band = el('div', 'lrp-band');                                   // the band's rect on the picture (the seam's frame)
      s.chip = el('div', 'lrp-chip');                                   // the opponent's chip, top-left of the opponent's tile
      s.vs = el('div', 'lrp-vs', 'VS');                                 // on the recording's own seam
      s.lchip = el('div', 'lrp-chip lrp-lchip');                         // CO-HOST (db/0271): this host's name on her own tile, link stretches only
      s.co = el('div', 'lrp-co', 'Co-host');
      s.band.appendChild(s.chip); s.band.appendChild(s.vs); s.band.appendChild(s.lchip); s.band.appendChild(s.co);
      s.timer = el('div', 'lrp-timer');
      s.intro = el('div', 'lrp-intro'); s.intro.hidden = true;
      s.res = el('div', 'lrp-res'); s.res.hidden = true;
      s.bar = el('div', 'lrp-bar');
      s.bar.innerHTML = '<span class="lrp-side lrp-sl"><span class="lrp-bav lrp-pic"></span><span class="lrp-lgc"></span><b class="lrp-pts">0</b></span>' +
        '<span class="lrp-track"><i class="lrp-fill"></i></span>' +
        '<span class="lrp-side lrp-sr"><b class="lrp-pts">0</b><span class="lrp-bav lrp-pic"></span><span class="lrp-lgc"></span></span>';
      s.id = 0; s.k = ''; s.resK = ''; s.introN = 0; s.seamK = null; s.seam = null;
      [s.res, s.intro, s.timer, s.bar, s.band].forEach(function (e) { root.insertBefore(e, root.firstChild); });
      return s;
    }
    function paintSide(sideEl, half) {
      var av = sideEl.querySelector('.lrp-bav');
      var u = half.user || {};
      var src = okSrc(u.avatar) ? 'url("' + String(u.avatar).replace(/["\\\n\r]/g, '') + '")' : '';
      if (av.style.backgroundImage !== src) { av.style.backgroundImage = src; }
      av.textContent = src ? '' : firstCp(u.display_name || u.username);
      av.classList.toggle('lrp-av-mono', !src);
      var lc = sideEl.querySelector('.lrp-lgc'), l = lgOf(half), lk = l ? l.tier : '';
      if (lc._k !== lk) { lc._k = lk; lc.innerHTML = l ? crest(l.tier, 16, l.name + ' league') : ''; lc.title = l ? l.name + ' league' : ''; }
    }
    function setupBattle(b) {
      if (!st) { st = buildStage(); }
      if (st.id === b.id) { return; }
      st.id = b.id; st.k = ''; st.resK = ''; st.introN = 0;
      paintSide(st.bar.querySelector('.lrp-sl'), b.left);
      paintSide(st.bar.querySelector('.lrp-sr'), b.right);
      var R = b.right || {}, ru = R.user || {}, rl = lgOf(R);
      st.chip.innerHTML = '';
      st.chip.appendChild(avatarOf(ru, 'lrp-chav'));
      st.chip.appendChild(el('b', '', ru.display_name || ru.username || 'Opponent'));
      if (rl) { var c = el('span', 'lrp-chlg'); c.innerHTML = crest(rl.tier, 15, rl.name + ' league'); st.chip.appendChild(c); }
      var lu = (b.left || {}).user || {};
      st.lchip.innerHTML = ''; st.lchip.appendChild(avatarOf(lu, 'lrp-chav')); st.lchip.appendChild(el('b', '', lu.display_name || lu.username || ''));
    }

    /* the overlay's geometry on the picture (layer px; geo from layout(): pr = the visible picture, top = under the viewer's header,
       bottom = above the controls / caption). Returns the y under which the chat list may run (null = the solo rule). With a seam:
       the score bar ABOVE the band (the recording is dark there), the clock / result strip astride the band's top edge, the chat
       under the band; no room above -> the bar under the band (the live room's order: band, clock on its bottom edge, bar); no
       room either side (a landscape band = the whole picture) -> the bar along the top. No seam: the bar along the top, the clock
       under it. The viewer's hands-free rail column (right 52 px of the box) is kept off the bar's right end. */
    var BAR_H = 30;
    function placeStage() {
      if (!st || !geo) { return null; }
      var pr = geo.pr, full = pr.full || { x: pr.left, y: pr.top, w: pr.right - pr.left, h: pr.bottom - pr.top };
      var W = pr.right - pr.left, H = pr.bottom - pr.top, fx = full.x - pr.left, fy = full.y - pr.top;
      var top = geo.top, bot = H - geo.bottom;
      var barR = 12;
      if (inPf || h.querySelector(':scope > [class*="pf-hf-"]')) { barR = Math.max(12, Math.round(pr.right - (geo.box.right - 52))); }
      var sm = st.seam, s = null;
      if (sm) {
        var bx0 = Math.max(0, fx + sm.x0 * full.w), bx1 = Math.min(W, fx + sm.x1 * full.w);
        var by0 = Math.max(0, fy + sm.y0 * full.h), by1 = Math.min(H, fy + sm.y1 * full.h);
        if (bx1 - bx0 >= 80 && by1 - by0 >= 40) {
          s = { x: bx0, y: by0, w: bx1 - bx0, h: by1 - by0, seam: Math.max(0, Math.min(bx1 - bx0, fx + sm.seam * full.w - bx0)), ox: Math.max(0, Math.min(bx1 - bx0 - 40, fx + sm.ox0 * full.w - bx0)) };
        }
      }
      root.classList.toggle('lrp-seam', !!s);
      root.classList.toggle('lrp-noseam', !s);
      var above = !!(s && s.y - 16 - BAR_H >= (inPf ? top : 4));   // the viewer keeps its header row clear; a card only its edge
      root.classList.toggle('lrp-above', above);   // the clock / result astride the band's TOP edge: the name chips step down under it
      var band = s || { x: 0, y: top, w: W, h: 44, seam: W / 2, ox: 0 };
      css(root, '--sx', Math.round(band.x) + 'px'); css(root, '--bt', Math.round(band.y) + 'px');
      css(root, '--sw', Math.round(band.w) + 'px'); css(root, '--bh', Math.round(band.h) + 'px');
      css(root, '--seam', Math.round(band.seam) + 'px'); css(root, '--opx', Math.round(band.ox) + 'px');
      var barT, barL = (s ? s.x : 0) + 12, barRt = Math.min(s ? s.x + s.w - 12 : W - 12, W - barR), timX = s ? s.x + s.seam : W / 2, timY, under, gb;
      if (above) {                                        // the bar above the band, the clock astride its top edge, chat under the band
        barT = s.y - 16 - BAR_H; timY = s.y - 13; under = s.y + s.h + 8; gb = s.y + 8;
      } else if (s && s.y + s.h + 18 + BAR_H <= bot - 4) { // the live room's order: band, clock on its bottom edge, bar
        timY = s.y + s.h - 13; barT = s.y + s.h + 18; under = barT + BAR_H + 8; gb = s.y + 8;
      } else {                                            // the bar along the top, the clock under it
        barT = top; timY = top + BAR_H + 6; under = Math.max(timY + 30, s && s.h < H * 0.8 ? s.y + s.h + 8 : 0); gb = timY + 30;   // the chat never runs over a band (a landscape band IS the picture)
        if (!s) { barL = 12; barRt = W - barR; }
      }
      css(st.bar, 'top', Math.round(barT) + 'px'); css(st.bar, 'left', Math.round(barL) + 'px'); css(st.bar, 'width', Math.max(120, Math.round(barRt - barL)) + 'px');
      st.bar.classList.toggle('lrp-bar-n', barRt - barL < 270);   // a small picture (a 390 feed card): the crests go, the track keeps its length
      css(st.timer, 'left', Math.round(timX) + 'px'); css(st.timer, 'top', Math.round(timY) + 'px');
      css(st.res, 'left', Math.round(timX) + 'px'); css(st.res, 'top', Math.round(timY) + 'px');
      var ir = s || { x: 0, y: 0, w: W, h: H };
      css(st.intro, 'left', Math.round(ir.x) + 'px'); css(st.intro, 'top', Math.round(ir.y) + 'px'); css(st.intro, 'width', Math.round(ir.w) + 'px'); css(st.intro, 'height', Math.round(ir.h) + 'px');
      css(root, '--gb', Math.round(gb) + 'px');
      if (root.classList.contains('lrp-link')) { return s ? Math.round(s.y + s.h + 8) : Math.round(top + 52); }   // co-host: names + label only
      if (root.classList.contains('lrp-tail')) { return s ? Math.round(s.y + s.h + 8) : null; }                // the band's tail: nothing drawn
      return Math.round(under);
    }

    function setMode(m, key) {
      if (m === mode && key === modeKey) { return; }
      var was = mode;
      mode = m; modeKey = key;
      root.classList.toggle('lrp-bmode', m === 'battle');
      if (was === 'battle' && m !== 'battle') {
        geo = null;
        if (st) { [st.band, st.bar, st.timer, st.intro, st.res].forEach(function (e) { e.remove(); }); st = null; }
        root.classList.remove('lrp-seam', 'lrp-noseam', 'lrp-above', 'lrp-tail', 'lrp-link', 'lrp-reson', 'lrp-final');
      }
      callFit(m === 'call' || m === 'battle');   // a battle band / a call: never cover-cropped sideways (the tiles stay whole)
      lastLayout = 0;
    }
    /* A CALL / ROOM IS NEVER COVER-CROPPED SIDEWAYS (the live room rule, 2026-10-12): the people at the grid's edges stay whole. A cover
       fit that would cut the frame's sides (a box narrower than the picture) becomes contain while the call is on screen; restored after. */
    var callSaved = null;
    function callFit(on) {
      if (!on) {
        if (callSaved) { if (callSaved[0]) { v.style.setProperty('object-fit', callSaved[0], callSaved[1]); } else { v.style.removeProperty('object-fit'); } callSaved = null; }
        return;
      }
      if (callSaved) { return; }
      var fit = ''; try { fit = getComputedStyle(v).objectFit; } catch (e) {}
      var vw = v.videoWidth || +v.getAttribute('width') || 0, vh = v.videoHeight || +v.getAttribute('height') || 0;
      var r = v.getBoundingClientRect();
      if ((fit === 'cover' || fit === 'fill') && vw > 0 && vh > 0 && r.width > 0 && r.height > 0 && r.width / r.height < vw / vh - 0.01) {
        callSaved = [v.style.getPropertyValue('object-fit'), v.style.getPropertyPriority('object-fit')];
        v.style.setProperty('object-fit', 'contain', 'important');
      }
    }

    function renderBattle(t, hit) {
      var b = hit.b;
      setupBattle(b);
      root.classList.toggle('lrp-tail', hit.tail);
      root.classList.toggle('lrp-link', !!hit.link);
      // the recording's own seam at t (the band can arrive / leave mid-battle): re-place the overlay when it, or the phase, changes
      var sm = rt && rt.bm ? null : seamAt(t);   // BUBBLE STAGE v2: the halves are bubbles, the recording's seam is not on screen
      var sk = (sm ? [sm.x0, sm.y0, sm.x1, sm.y1, sm.seam].map(function (n) { return n.toFixed(3); }).join(',') : '-') + '|' + hit.tail + '|' + !!hit.link;
      if (st.seamK !== sk) { st.seamK = sk; st.seam = sm; lastLayout = Date.now(); layout(); }
      st.chip.hidden = hit.tail && !hit.link;   // the opponent's chip on the opponent's tile, as the live room draws it (not in the tail; CSS: never without a seam outside a link)
      if (hit.link) { st.intro.hidden = true; st.res.hidden = true; root.classList.remove('lrp-reson', 'lrp-final'); return; }   // CO-HOST: names + label only
      var bw = b.wall || b, tw = b.wall ? wallAt(d, t) : t;   // the battle clock on the wall (the map's inverse)
      var endAt = bw.start_ms + b.duration_s * 1000;
      var inResult = t >= b.end_ms;
      var sc = inResult && b.result ? [b.result.left_points, b.result.right_points] : scoreAt(b, Math.min(t, b.end_ms));
      // the clock pill (livebattle.js tick): BATTLE m:ss | FINAL SECONDS m:ss (red, pulsing) | RESULT m:ss (gold)
      var tcls = 'lrp-timer', thtml;
      if (t < b.start_ms) { thtml = '<em>Battle</em><b>' + clock(b.duration_s * 1000) + '</b>'; }
      else if (!inResult) {
        var e = Math.max(0, Math.min(b.duration_s * 1000, endAt - tw)), fin = e <= 30000;
        tcls += fin ? ' lrp-t-final' : '';
        thtml = (fin ? '<em>Final seconds</em>' : '<em>Battle</em>') + '<b>' + clock(e) + '</b>';
      } else { tcls += ' lrp-t-res'; thtml = '<em>Result</em><b>' + clock(Math.max(0, bw.result_end_ms - tw)) + '</b>'; }
      var k = sc[0] + '|' + sc[1] + '|' + tcls + '|' + thtml;
      if (k !== st.k) {
        st.k = k;
        st.bar.querySelector('.lrp-sl .lrp-pts').textContent = fmtBar(sc[0]);
        st.bar.querySelector('.lrp-sr .lrp-pts').textContent = fmtBar(sc[1]);
        var tot = sc[0] + sc[1];
        st.bar.querySelector('.lrp-fill').style.width = (tot > 0 ? Math.max(4, Math.min(96, Math.round(sc[0] / tot * 1000) / 10)) : 50) + '%';
        st.timer.className = tcls; st.timer.innerHTML = thtml;
        root.classList.toggle('lrp-final', !inResult && t >= b.start_ms && endAt - tw <= 30000);
      }
      // the 3-2-1
      if (t >= b.intro_ms && t < b.start_ms) {
        var n = Math.max(1, Math.min(3, Math.ceil((bw.start_ms - tw) / 1000)));
        if (st.introN !== n) {
          st.introN = n;
          var a = lgOf(b.left), c = lgOf(b.right);
          st.intro.innerHTML = '<b>' + n + '</b><span>Battle starts</span>' + (a && c ? '<i class="lrp-lgvs">' + crest(a.tier, 18) + '<span>' + esc(a.name) + '</span><em>vs</em><span>' + esc(c.name) + '</span>' + crest(c.tier, 18) + '</i>' : '');
          st.intro.classList.remove('pop'); void st.intro.offsetWidth; if (!reduce && !seekMode) { st.intro.classList.add('pop'); }
        }
        st.intro.hidden = false;
      } else { st.intro.hidden = true; st.introN = 0; }
      // the result over the band (the after-party), GOLD decides (2026-10-12)
      var showRes = !hit.tail && t >= (b.result_ms || b.end_ms) && !!b.result;
      root.classList.toggle('lrp-reson', showRes);   // the small result strip takes the clock's place (2026-10-12: never over the faces)
      if (showRes) {
        if (st.resK !== String(b.id)) { st.resK = String(b.id); st.res.innerHTML = resHtml(b); }
        st.res.hidden = false;
      } else { st.res.hidden = true; }
    }

    function resHtml(b) {
      var r = b.result || {}, L = b.left || {}, R = b.right || {};
      var nm = function (u) { return u ? (u.display_name || ('@' + (u.username || ''))) : ''; };
      var win = r.outcome === 'left' ? L : (r.outcome === 'right' ? R : null);
      var head = win ? esc(nm(win.user)) + ' wins!' : 'It’s a draw';
      var why = r.left_by ? (nm(r.left_by === 'left' ? L.user : R.user) + (r.reason === 'quit' ? ' left the battle' : '’s live ended')) : '';
      var gold = r.left_gold != null && (r.left_gold !== r.left_points || r.right_gold !== r.right_points) ? '<span class="lrp-why">Gold ' + fmtBar(r.left_gold) + ' – ' + fmtBar(r.right_gold) + '</span>' : '';
      var lp = function (h) {
        var l = lgOf(h), bt = l && l.battle; if (!bt) { return ''; }
        if (bt.counted === false || (bt.reason && !bt.lp)) {   // say why it did not count, never a bare "0 LP"
          var w = { friendly: 'Friendly', linked: 'Linked hosts', pair_daily_cap: 'Daily limit', creator_daily_cap: 'Daily limit' }[bt.reason] || 'No LP';
          return '<i class="lrp-lpd">' + esc(w) + ' · no LP</i>';
        }
        return '<i class="lrp-lpd' + (bt.lp > 0 ? ' up' : (bt.lp < 0 ? ' down' : '')) + '">' + (bt.lp > 0 ? '+' : '') + bt.lp + ' LP</i>';
      };
      var mv = function (list) {
        return (list || []).length ? (list || []).slice(0, 3).map(function (m) {
          var u = m.user || {};
          return '<li>' + (okSrc(u.avatar) ? '<span class="lrp-mav lrp-pic" style="background-image:url(&quot;' + esc(String(u.avatar).replace(/["\\\n\r]/g, '')) + '&quot;)"></span>' : '<span class="lrp-mav lrp-av-mono">' + (u.id ? esc(firstCp(nm(u).replace(/^@/, ''))) : 'P') + '</span>')
            + '<b>' + esc(u.id ? nm(u) : 'A Patron') + '</b><i>' + fmtBar(m.gold) + '</i></li>';
        }).join('') : '<li class="lrp-none">No gifts</li>';
      };
      return '<div class="lrp-res-c lrp-o-' + esc(r.outcome || 'draw') + '"><span class="lrp-crown" aria-hidden="true">' + (win ? '👑' : '🤝') + '</span>' +
        '<strong>' + head + '</strong><span class="lrp-score">' + fmtBar(r.left_points) + ' – ' + fmtBar(r.right_points) + '</span>' + gold +
        (why ? '<span class="lrp-why">' + esc(why) + '</span>' : '') +
        '<div class="lrp-mvps"><div><em>Top gifters</em>' + lp(L) + '<ol>' + mv(L.mvps) + '</ol></div><div><em>Top gifters</em>' + lp(R) + '<ol>' + mv(R.mvps) + '</ol></div></div></div>';
    }

    /* ---------- CALLS: name pills from the recorded layout (framing.layouts, db/0270) ---------- */
    function layoutAt(t) {
      var ls = (framing() || {}).layouts || [], ans = null;
      for (var i = 0; i < ls.length; i++) { if (ls[i].t_ms <= t) { ans = ls[i]; } else { break; } }
      return ans && (ans.mode === 'grid' || ans.mode === 'room') ? ans : null;
    }
    /* THE PILLS ARE THE LIVE WATCH PAGE'S (app.js lwChips, Rob's rules 2026-10-12; rova.css .lw-cchip / .lw-cav / .lw-cnm / .lw-cseat, the
       same classes): the HOST's tile (the broadcaster; else seat 0 / tile 0) gets NO pill; every other tile's pill sits at the TOP-RIGHT
       of its VISIBLE tile (Rob 2026-10-14: at the bottom it collided with the chat rows and the controls), 8 px in from the right and top
       edges, wholly inside the tile (max-width = the visible width - 16); on the pill: photo, name (ellipsis). The viewer's header row
       (or a badge on the media's top edge) over that corner DROPS it to 8 px under the header; the awake hands-free rail crossing it moves it
       8 px left of the rail and the name shortens ("Dj Mike…", >= ~4 characters; then the seat number goes; then the pill) -- the full name is
       back when the controls hide (topObs). A tile too narrow (< 48) or too short gets none. Every grid / side2 / band / room-seat layout is the
       same rule (tiles come from the recorded layout); battles draw no pills (the opponent chip is the stage's).
       (Mute state is not in the recorded layout yet: replays draw no mic disc.) */
    var PIN = 8;
    var mctx = null;
    function textW(el, str) {   // the width of str in el's font (a canvas measure; no layout)
      try {
        if (!mctx) { mctx = document.createElement('canvas').getContext('2d'); }
        var cs = getComputedStyle(el);
        mctx.font = (cs.fontStyle || 'normal') + ' ' + (cs.fontWeight || '400') + ' ' + cs.fontSize + ' ' + cs.fontFamily;
        return mctx.measureText(str).width;
      } catch (e) { return str.length * 7; }
    }
    function renderPills(t) {
      var lay = callAt(t) ? layoutAt(t) : null;
      var k = lay ? lay.t_ms + ':' + lay.mode : '';
      if (k === pillsKey) { return; }
      pillsKey = k;
      if (pills) { pills.remove(); pills = null; }
      if (!lay) { return; }
      pills = el('div', 'lrp-pills');
      var hostId = +((d.meta && d.meta.host && d.meta.host.id) || 0), room = lay.mode === 'room';
      (lay.tiles || []).forEach(function (tl, i) {
        var u = tl.user;
        if (!u) { return; }
        var isHost = hostId ? +u.id === hostId : (room ? +tl.seat === 0 : i === 0);
        if (isHost) { return; }
        var name = u.display_name || (u.username ? '@' + u.username : '');
        if (!name) { return; }
        var p = el('span', 'lw-cchip');
        if (room && +tl.seat > 0) { p.appendChild(el('b', 'lw-cseat', String(+tl.seat))); }
        var av = el('span', 'lw-cav');
        av.setAttribute('data-ini', firstCp(name.replace(/^@/, '')));
        // the photo as a background-image span over the monogram (= .lw-cav img; an <img> inside .post .media would catch the media rules)
        if (okSrc(u.avatar)) { av.appendChild(pic('lrp-cavp', u.avatar)); }
        p.appendChild(av);
        p.appendChild(el('span', 'lw-cnm', name));
        p.__t = tl; p.__w = lay.w; p.__h = lay.h;
        pills.appendChild(p);
      });
      root.appendChild(pills);
      layout();   // place them now (a paused seek renders once)
    }
    /* returns the lowest pill bottom (layer px) over the chat column, or null */
    function placePills(box, pr, obs) {
      var full = pr.full; if (!full || !full.w) { return null; }
      var lr = list.getBoundingClientRect(), cap = null;
      for (var i = 0; i < pills.children.length; i++) {
        var p = pills.children[i], tl = p.__t, kx = full.w / p.__w, ky = full.h / p.__h;
        // the tile's VISIBLE rect (viewport px): the tile in the picture, inside the visible picture
        var vx0 = Math.max(pr.left, full.x + tl.x * kx), vx1 = Math.min(pr.right, full.x + (tl.x + tl.w) * kx);
        var vy0 = Math.max(pr.top, full.y + tl.y * ky), vy1 = Math.min(pr.bottom, full.y + (tl.y + tl.h) * ky);
        var r = vx1 - PIN, t = vy0 + PIN, mw = r - (vx0 + PIN);
        if (vx1 - vx0 < 48 || mw < 36) { p.hidden = true; continue; }
        p.hidden = false;
        css(p, 'max-width', mw.toFixed(1) + 'px');
        var pw = Math.min(mw, p.offsetWidth || 160);
        // a header over the corner drops the pill under it; the rail crossing its line steps it left (3 passes)
        for (var pass = 0; pass < 3; pass++) {
          var moved = false, l = r - pw;
          for (var j = 0; j < (obs || []).length; j++) {
            var o = obs[j];
            if (o.k === 'bot' || !(o.l < r && o.r > l && o.t < t + 24 && o.b + (o.k === 'top' ? PIN : 0) > t)) { continue; }   // 8 px clear under a header
            if (o.k === 'side') { r = o.l - PIN; } else { t = o.b + PIN; }
            moved = true;
          }
          if (!moved) { break; }
        }
        var mw2 = r - (vx0 + PIN);
        // what fits in mw2: the whole name > a name cut to >= ~4 characters + ellipsis > that without the seat number > nothing (hidden)
        var nm = p.querySelector('.lw-cnm'), seat = p.querySelector('.lw-cseat');
        if (seat) { seat.style.display = ''; }
        var nmW = nm ? nm.scrollWidth : 0, chrome = p.offsetWidth - (nm ? nm.getBoundingClientRect().width : 0);
        var minNm = nm ? textW(nm, (nm.textContent || '').slice(0, 4)) + textW(nm, '…') : 0;
        var tooNarrow = mw2 < chrome + Math.min(nmW, minNm);
        if (tooNarrow && seat) { var sw = seat.getBoundingClientRect().width + 6; if (mw2 >= chrome - sw + Math.min(nmW, minNm)) { seat.style.display = 'none'; chrome -= sw; tooNarrow = false; } }
        var hide = mw2 < 36 || tooNarrow || t + 24 > vy1 - 4, l2 = r - Math.min(mw2, chrome + nmW);
        for (var q = 0; q < (obs || []).length && !hide; q++) { var ob = obs[q]; if (ob.k === 'bot' && ob.l < r && ob.r > l2 && ob.t < t + 24 && ob.b > t) { hide = true; } }
        p.hidden = hide;
        if (hide) { continue; }
        css(p, 'right', (pr.right - r).toFixed(1) + 'px');
        css(p, 'top', (t - pr.top).toFixed(1) + 'px');
        css(p, 'max-width', mw2.toFixed(1) + 'px');
        if (lr.width && l2 < lr.right && r > lr.left) { cap = Math.max(cap == null ? 0 : cap, t + 24 - pr.top); }
      }
      return cap;
    }

    /* ---------- PAUSED STRETCHES (2026-10-22, Rob's batch item 24, /p/58193 "started going static"): framing.paused_runs = where the
       recording is the relay's "Video paused" card / the app's "Be right back" slate (the host's camera was off: an iPhone host who
       left Safari, a hidden tab). The sound goes on there (a DJ keeps playing), so nothing is skipped by itself: a pill over the still
       says so and offers the jump to where the camera comes back ("Skip 2:31"). Chapters carry the same stretches (paused / resume). */
    var skipEl = null, skipRun = null;
    function pausedAt(t) {
      var rs = (framing() || {}).paused_runs || [];
      for (var i = 0; i < rs.length; i++) { if (t >= rs[i][0] && t < rs[i][1] - 1200) { return rs[i]; } }
      return null;
    }
    function renderSkip(t) {
      var r = mode === 'battle' ? null : pausedAt(t);
      if (!r) { if (skipEl) { skipEl.hidden = true; } skipRun = null; return; }
      if (!skipEl) {
        skipEl = el('button', 'lrp-skip');
        skipEl.type = 'button';
        skipEl.appendChild(el('span', 'lrp-skip-t'));
        skipEl.appendChild(el('em', 'lrp-skip-n'));
        skipEl.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (!skipRun) { return; }
          try { v.currentTime = Math.max(0, (skipRun[1] - partStart()) / 1000 + 0.25); } catch (x) {}
          if (v.paused) { try { var pp = v.play(); if (pp && pp.catch) { pp.catch(function () {}); } } catch (x) {} }
        });
        ['pointerdown', 'touchstart', 'dblclick', 'mousedown'].forEach(function (ev) { skipEl.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true }); });
        root.appendChild(skipEl);
      }
      skipRun = r;
      var left = Math.max(1, Math.round((r[1] - t) / 1000));
      var txt = r[2] === 'dark' ? 'Host is away' : 'Video paused';
      var n = 'Skip ' + (left >= 60 ? Math.floor(left / 60) + ':' + ('0' + (left % 60)).slice(-2) : left + 's') + ' ▸';
      var a = skipEl.firstChild, b = skipEl.lastChild;
      if (a.textContent !== txt) { a.textContent = txt; }
      if (b.textContent !== n) { b.textContent = n; skipEl.setAttribute('aria-label', txt + ': skip ' + left + ' seconds to where the video comes back'); }
      skipEl.hidden = false;
    }

    /* ---------- THE BUBBLE STAGE (2026-10-22 item 23, v2 2026-10-23: REPLAY FRAMING v2, Rob: "the old grid look is OUT everywhere,
       replays too; bubbles only"). A room / call / battle replay is ONE recording: the host's composite, empty seats and all. While the
       recorded layout (framing.layouts, db/0270) says a room or grid was the picture -- or a battle / co-host link is on
       (framing.battles: each half's people over time) -- the player draws the live's own bubble stage instead of the composite:
         - only the people ON AIR (tile.on), each in its own bubble = the live's .lw-bub (rova.css: radius 8.5% of the short side,
           14-26 px, soft drop shadow, glass rim). Video = a <canvas> per person, drawImage of that person's tile in THIS recording
           (cover, 30% of a vertical overflow cut above = the compositor's CROP_Y). No video for them in this recording, or their
           camera off / audio only / away / connecting (db/0343 tile states) = the PHOTO CARD (blurred photo, round photo, name,
           what they were doing) -- never a black seat.
         - laid out by window.__rovaBubblePlan (app.js: the live's own planner) by count: 1 = the host full in the picture's own
           rect (a solo replay's look), 2+ = big bubbles filling the window; a battle = each HALF its own stage (left = this live's
           side, right = the opponent's), under the score bar, 8 px pad / gap.
         - changes animate with the live's round-4 springs: join .86 -> 1.04 -> 1 (520 ms), move / re-flow 520 ms ease-out-back,
           leave 1 -> 1.06 -> .5 + fade (360 ms); reduced motion = 200 ms fades; framing.bubbles false = no animation at all.
       Frames: requestVideoFrameCallback (one draw per decoded frame), else rAF while playing; nothing while paused (a seek draws once),
       offscreen or hidden. The <video> keeps playing underneath (sound, controls, PiP). Kill switch: k/v live_replay_retile ('off';
       'noapple' = not on Apple's native HLS player) -> meta.framing.retile (default on, every client). Debug: __rovaReplay.of(v).dbg().rt */
    var RT_CROP_Y = 0.3, RT_INSET = 6 / 720;   // vertical overflow cut above; the source tile's rounded edge trimmed
    var RT_JOIN = 520, RT_MOVE = 520, RT_LEAVE = 360, RT_GAP = 8;
    var rt = null;                              // {el, bubbles{k: B}, key, n, on, vfc, raf, draws, instant, size, ppl, bm}
    var rtOk = null;
    function rtAllowed() {
      var f = framing(), m = String((f && f.retile) || 'on');
      if (m === 'off') { return false; }
      if (m === 'noapple') {
        try { if (!v._hls && /apple/i.test(navigator.vendor || '') && v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl')) { return false; } } catch (e) {}
      }
      if (rtOk === null) { try { rtOk = !!document.createElement('canvas').getContext('2d'); } catch (e) { rtOk = false; } }
      return rtOk;
    }
    function rtAnim() { var f = framing(); return !reduce && !(f && f.bubbles === false); }
    function stateOf(tl) {
      if (!tl) { return ''; }
      if (tl.connecting) { return 'connecting'; }
      if (tl.away) { return 'away'; }
      if (tl.audio_only) { return 'audio'; }
      if (tl.camera_off) { return 'camoff'; }
      return '';
    }
    /* the layout entry of THIS recording at t (any mode; null before the first) */
    function recAt(t) {
      var ls = (framing() || {}).layouts || [], ans = null;
      for (var i = 0; i < ls.length; i++) { if (ls[i].t_ms <= t) { ans = ls[i]; } else { break; } }
      return ans;
    }
    /* where person uid is in THIS recording at t: {tl, lw, lh} (tile rect in the layout's frame) or null (not in the picture) */
    function srcOf(uid, t, isHostHere) {
      var lay = recAt(t), f = framing() || {};
      if (lay && (lay.mode === 'room' || lay.mode === 'grid' || lay.mode === 'band') && lay.w > 0 && lay.h > 0) {
        var ts = lay.tiles || [];
        for (var i = 0; i < ts.length; i++) {
          var tl = ts[i], tu = +(tl.user_id || (tl.user && tl.user.id) || 0);
          if ((tl.on != null ? tl.on : !!tl.user) && tu && tu === +uid) { return { tl: tl, lw: lay.w, lh: lay.h }; }
        }
        return null;
      }
      // camera only: the whole frame is this live's host
      var fw = (f.frame && f.frame.w) || v.videoWidth, fh = (f.frame && f.frame.h) || v.videoHeight;
      return isHostHere && fw > 0 && fh > 0 ? { tl: { x: 0, y: 0, w: fw, h: fh }, lw: fw, lh: fh } : null;
    }
    function personOf(k, tl, src, user, host, state) {
      return { k: k, host: host, tl: src ? src.tl : null, lw: src ? src.lw : 0, lh: src ? src.lh : 0, user: user || null, state: state || '',
               asp: src ? src.tl.w / src.tl.h : 0.75 };
    }
    /* the people ON AIR at t in a room / grid picture, host first: [person] (null = no room / grid picture at t) */
    function rtPeopleAt(t) {
      var lay = layoutAt(t);
      if (!lay || !(lay.w > 0 && lay.h > 0)) { return null; }
      var hostId = +((d.meta && d.meta.host && d.meta.host.id) || 0), room = lay.mode === 'room', out = [];
      (lay.tiles || []).forEach(function (tl, i) {
        var on = tl.on != null ? !!tl.on : !!tl.user;
        if (!on || !(tl.w > 0 && tl.h > 0)) { return; }
        var uid = +(tl.user_id || (tl.user && tl.user.id) || 0);
        var isHost = hostId && uid ? uid === hostId : (room ? +tl.seat === 0 : i === 0);
        var p = personOf(uid ? 'u' + uid : 's' + (room ? +tl.seat : i), tl, { tl: tl, lw: lay.w, lh: lay.h }, tl.user, isHost, stateOf(tl));
        p.i = i; out.push(p);
      });
      if (!out.length) { return null; }
      out.sort(function (a, b) { return (b.host - a.host) || (a.i - b.i); });
      return out;
    }
    /* a battle / co-host link at t: its two halves' people (framing.battles), or null (no side data: the old overlay stays) */
    function sidesOf(bid) {
      var bs = (framing() || {}).battles || [];
      for (var i = 0; i < bs.length; i++) { if (String(bs[i].id) === String(bid)) { return bs[i]; } }
      return null;
    }
    function rtHalvesAt(t, hit) {
      var sd = hit && hit.b ? sidesOf(hit.b.id) : null;
      if (!sd) { return null; }
      var out = [];
      ['left', 'right'].forEach(function (side, si) {
        var list = sd[side] || [], e = null;
        for (var i = 0; i < list.length; i++) { if (list[i].t_ms <= t || !e) { e = list[i]; } if (list[i].t_ms > t) { break; } }
        var hu = (hit.b[side] && hit.b[side].user) || null, hid = +((hu && hu.id) || 0), ppl = [];
        var tiles = e && e.layout_mode && e.layout_mode !== 'band' ? (e.tiles || []) : [];
        tiles.forEach(function (tl, j) {
          var on = tl.on != null ? !!tl.on : !!tl.user, uid = +(tl.user_id || (tl.user && tl.user.id) || 0);
          if (!on || !uid) { return; }
          var host = uid === hid, src = srcOf(uid, t, si === 0 && host);
          var p = personOf((si ? 'R' : 'L') + uid, tl, src, tl.user || (host ? hu : null), host, stateOf(tl));
          p.i = j; ppl.push(p);
        });
        if (!ppl.some(function (p) { return p.host; }) && hid) {   // camera only / the battle call / no row: that half's host alone
          var bt = e && e.layout_mode === 'band' ? (e.tiles || [])[0] : null;
          var hp = personOf((si ? 'R' : 'L') + hid, bt, srcOf(hid, t, si === 0), hu, true, stateOf(bt));
          hp.i = -1; ppl.push(hp);
        }
        ppl.sort(function (a, b) { return (b.host - a.host) || (a.i - b.i); });
        out.push(ppl);
      });
      return out;
    }
    /* where the stage draws (viewport px): one person = the picture's own rect (a solo replay's look), more / a battle = the window
       (a portrait box: all of it; a wide box: a centred column no wider than 1.3x its height -- 1.9x for two battle halves) */
    function rtRegion(box, n, bm) {
      if (n <= 1 && !bm) { return null; }   // = picRect
      var w = box.width, hh = box.height, cw = w > hh ? Math.min(w, hh * (bm ? 1.9 : 1.3)) : w, x = box.left + (w - cw) / 2;
      return { left: x, top: box.top, right: x + cw, bottom: box.top + hh, full: { x: x, y: box.top, w: cw, h: hh } };
    }
    /* THE LAYOUT BY COUNT inside one region (layer px): the live's planner, else the same idea here */
    function rtPlan(ppl, x0, y0, W, H, pad) {
      var n = ppl.length;
      if (n === 1 && !pad) { return [{ x: x0, y: y0, w: W, h: H, full: true }]; }
      var AW = W - 2 * pad, AH = H - 2 * pad, asp = ppl.map(function (p) { return p.asp; }), plan = null;
      if (typeof window.__rovaBubblePlan === 'function') { try { plan = window.__rovaBubblePlan(n, AW, AH, RT_GAP, asp); } catch (e) { plan = null; } }
      if (!plan || plan.length !== n) {
        var c = n <= 2 ? 1 : 2, rows = Math.ceil(n / c), cw = (AW - (c - 1) * RT_GAP) / c, ch = (AH - (rows - 1) * RT_GAP) / rows;
        plan = ppl.map(function (p, i) { return { l: (i % c) * (cw + RT_GAP), t: Math.floor(i / c) * (ch + RT_GAP), w: cw, h: ch }; });
      }
      return plan.map(function (b) { return { x: x0 + pad + b.l, y: y0 + pad + b.t, w: b.w, h: b.h }; });
    }
    /* the source rect (video px) a bubble of w x h shows: the tile, its rounded edge trimmed, cover-fit (vertical overflow 30% above) */
    function rtSrc(p, w, h) {
      var vw = v.videoWidth, vh = v.videoHeight;
      if (!p.tl || !(vw > 0 && vh > 0 && w > 0 && h > 0 && p.lw > 0 && p.lh > 0)) { return null; }
      var kx = vw / p.lw, ky = vh / p.lh, ins = p.tl.w >= p.lw - 1 ? 0 : RT_INSET * Math.min(p.lw, p.lh);
      var sx = (p.tl.x + ins) * kx, sy = (p.tl.y + ins) * ky, sw = (p.tl.w - 2 * ins) * kx, sh = (p.tl.h - 2 * ins) * ky;
      if (sw <= 2 || sh <= 2) { return null; }
      var a = w / h;
      if (sw / sh > a) { var nw = sh * a; sx += (sw - nw) / 2; sw = nw; }
      else { var nh = sw / a; sy += (sh - nh) * RT_CROP_Y; sh = nh; }
      return [sx, sy, sw, sh];
    }
    function rtLive(B) { return !!(B.p.tl && !B.p.state); }   // video only for someone in this picture with their camera on
    function rtDraw() {
      if (!rt || !rt.on || !v.videoWidth || v.readyState < 2) { return; }
      for (var k in rt.bubbles) {
        var B = rt.bubbles[k];
        if (B.gone || !B.cx || !rtLive(B)) { continue; }
        if (!B.src || B.vw !== v.videoWidth || B.vh !== v.videoHeight) { B.src = rtSrc(B.p, B.w, B.h); B.vw = v.videoWidth; B.vh = v.videoHeight; }
        if (!B.src) { continue; }
        try { B.cx.drawImage(v, B.src[0], B.src[1], B.src[2], B.src[3], 0, 0, B.cv.width, B.cv.height); B.drawn = true; } catch (e) {}
        if (B.drawn && !B.el.classList.contains('is-live')) { B.el.classList.add('is-live'); }
      }
      rt.draws++;
    }
    function rtLoop() {
      if (!rt || !rt.on || !visible || document.hidden) { return; }
      if (v.requestVideoFrameCallback) {
        if (rt.vfc == null) { rt.vfc = v.requestVideoFrameCallback(function () { if (rt) { rt.vfc = null; rtDraw(); rtLoop(); } }); }
      } else if (!v.paused && !v.ended && rt.raf == null) {
        rt.raf = requestAnimationFrame(function () { rtDraw(); if (rt) { rt.raf = null; rtLoop(); } });
      }
    }
    var ST_TXT = { camoff: 'Camera off', audio: 'Audio only', away: 'Away', connecting: 'Connecting…' };
    /* the photo card (the live's .lw-bub-ph: blurred photo, round photo, name) + what they were doing */
    function rtCard(B) {
      var u = B.p.user || {}, name = u.display_name || (u.username ? '@' + u.username : '');
      var ph = el('div', 'lw-bub-ph'), bg = el('span', 'lw-bub-bg'), av = el('span', 'lw-bub-av'), big = u.avatar_lg || u.avatar;
      if (okSrc(big)) { bg.style.backgroundImage = 'url("' + String(big).replace(/["\\\n\r]/g, '') + '")'; }
      av.setAttribute('data-ini', firstCp((name || '?').replace(/^@/, '')));
      if (okSrc(u.avatar || big)) { av.appendChild(pic('lrp-rt-avp', u.avatar || big)); }
      ph.appendChild(bg); ph.appendChild(av);
      if (name) { ph.appendChild(el('span', 'lw-bub-nm', name)); }
      B.stEl = el('span', 'lrp-rt-st'); ph.appendChild(B.stEl);
      B.el.appendChild(ph);
    }
    function rtNameTag(B) {
      var u = B.p.user;
      var name = u ? (u.display_name || (u.username ? '@' + u.username : '')) : '';
      if (!name) { return; }
      var tag = el('span', 'lrp-rt-nm'), av = el('span', 'lrp-rt-av');
      av.setAttribute('data-ini', firstCp(name.replace(/^@/, '')));
      if (okSrc(u.avatar)) { av.appendChild(pic('lrp-rt-avp', u.avatar)); }
      tag.appendChild(av);
      tag.appendChild(el('b', '', name));
      B.el.appendChild(tag);
      B.tag = tag;
    }
    function rtBubble(p) {
      var B = { p: p, el: el('div', 'lrp-rt-b lw-bub'), cv: document.createElement('canvas'), cx: null, w: 0, h: 0, src: null, gone: false, drawn: false };
      B.cx = B.cv.getContext('2d');
      B.el.appendChild(B.cv);
      rtCard(B);
      if (p.tag) { rtNameTag(B); }
      return B;
    }
    function rtPaintState(B) {
      var live = rtLive(B);
      if (!live) { B.el.classList.remove('is-live'); B.drawn = false; }
      B.el.classList.toggle('is-audio', B.p.state === 'audio');
      B.el.classList.toggle('is-join', B.p.state === 'connecting');
      if (B.stEl) { var tx = B.p.state ? ST_TXT[B.p.state] || '' : (B.p.tl ? '' : ''); if (B.stEl.textContent !== tx) { B.stEl.textContent = tx; } }
    }
    function rtSpring(e, frames, ms, easing) { try { return e.animate(frames, { duration: ms, easing: easing || 'linear', fill: 'none' }); } catch (x) { return null; } }
    /* place every bubble (groups = [{x, y, w, h, pad, ppl}] in layer px); join / move / leave with the live's springs */
    function rtPlace(groups) {
      var seen = {}, dpr = Math.min(2, window.devicePixelRatio || 1), anim = rtAnim() && !rt.instant, still = reduce && !rt.instant;
      var lr = root.getBoundingClientRect(), ox = lr.left, oy = lr.top;   // the layer's origin now (it moves between one person and many)
      groups.forEach(function (g) {
        var rects = rtPlan(g.ppl, g.x, g.y, g.w, g.h, g.pad);
        g.ppl.forEach(function (p, i) {
          var r = rects[i], B = rt.bubbles[p.k], fresh = !B;
          p.tag = !p.host || g.tagHost;
          if (fresh) { B = rt.bubbles[p.k] = rtBubble(p); rt.el.appendChild(B.el); }
          else if (B.gone) { B.gone = false; if (B.leaveA) { try { B.leaveA.cancel(); } catch (e) {} B.leaveA = null; } }
          var oldP = B.p; B.p = p; seen[p.k] = 1;
          if (!fresh && (!!oldP.tag) !== (!!p.tag)) { if (B.tag) { B.tag.remove(); B.tag = null; } if (p.tag) { rtNameTag(B); } }
          var old = fresh ? null : { x: B.x + (B.ox - ox), y: B.y + (B.oy - oy), w: B.w, h: B.h };
          B.x = r.x; B.y = r.y; B.w = r.w; B.h = r.h; B.ox = ox; B.oy = oy; B.src = null;
          B.el.classList.toggle('lrp-rt-full', !!r.full);
          B.el.classList.toggle('lrp-rt-sm', r.w < 110 || r.h < 90);
          css(B.el, 'border-radius', r.full ? '0px' : Math.round(Math.max(14, Math.min(26, Math.min(r.w, r.h) * 0.085))) + 'px');
          if (B.tag) { css(B.tag, 'top', Math.round(Math.max(8, (inPf ? 58 : 0) - r.y + 8)) + 'px'); }   // a name never sits under the viewer's header row
          css(B.el, 'left', r.x.toFixed(1) + 'px'); css(B.el, 'top', r.y.toFixed(1) + 'px');
          css(B.el, 'width', r.w.toFixed(1) + 'px'); css(B.el, 'height', r.h.toFixed(1) + 'px');
          var cw = Math.max(2, Math.round(r.w * dpr)), ch = Math.max(2, Math.round(r.h * dpr));
          if (B.cv.width !== cw || B.cv.height !== ch) { B.cv.width = cw; B.cv.height = ch; B.drawn = false; }
          rtPaintState(B);
          if (fresh) {
            B.el.style.transformOrigin = '50% 50%';   // grows from its centre
            if (anim) { rtSpring(B.el, [{ transform: 'scale(.86)', opacity: 0, offset: 0, easing: 'cubic-bezier(.22,.9,.24,1)' }, { opacity: 1, offset: 0.4 },
                                         { transform: 'scale(1.04)', offset: 0.6, easing: 'cubic-bezier(.22,.9,.24,1)' }, { transform: 'scale(1)', opacity: 1, offset: 1 }], RT_JOIN); }
            else if (still) { rtSpring(B.el, [{ opacity: 0 }, { opacity: 1 }], 200); }
            rt.flips++;
          } else if (old && anim && (Math.abs(old.x - r.x) > 0.5 || Math.abs(old.y - r.y) > 0.5 || Math.abs(old.w - r.w) > 0.5 || Math.abs(old.h - r.h) > 0.5)) {
            // FLIP: from where it was to where it is, ease-out-back (~4% overshoot)
            B.el.style.transformOrigin = '0 0';
            rtSpring(B.el, [{ transform: 'translate(' + (old.x - r.x).toFixed(1) + 'px,' + (old.y - r.y).toFixed(1) + 'px) scale(' + (old.w / r.w).toFixed(4) + ',' + (old.h / r.h).toFixed(4) + ')' },
                            { transform: 'none' }], RT_MOVE, 'cubic-bezier(.34,1.32,.64,1)');
            rt.flips++;
          }
        });
      });
      Object.keys(rt.bubbles).forEach(function (k) {
        if (seen[k]) { return; }
        var B = rt.bubbles[k];
        if (B.gone) { return; }
        B.gone = true;
        var a = null;
        if (rtAnim() && !rt.instant) {
          B.el.style.transformOrigin = '50% 50%';
          B.el.classList.remove('is-live');   // to its photo (the canvas fades on the .lw-bub rule)
          a = rtSpring(B.el, [{ transform: 'scale(1)', opacity: 1, offset: 0, easing: 'ease-out' }, { transform: 'scale(1.06)', opacity: 1, offset: 0.3, easing: 'cubic-bezier(.55,0,.75,.2)' },
                              { transform: 'scale(.5)', opacity: 0, offset: 1 }], RT_LEAVE);
        } else if (still) { a = rtSpring(B.el, [{ opacity: 1 }, { opacity: 0 }], 200); }
        if (!a) { B.el.remove(); delete rt.bubbles[k]; return; }
        B.leaveA = a; B.el.style.opacity = '0';
        a.onfinish = function () { if (rt && rt.bubbles[k] === B && B.gone) { B.el.remove(); delete rt.bubbles[k]; } };
      });
      Object.keys(rt.bubbles).forEach(function (k) { var B = rt.bubbles[k]; if (!B.gone) { B.el.style.opacity = ''; } });
      rt.places++;
      rt.instant = false;
      rt.size = root.clientWidth + 'x' + root.clientHeight;
      rtDraw();
    }
    function rtOff() {
      if (!rt) { return; }
      var R = rt; rt = null;
      if (R.vfc != null && v.cancelVideoFrameCallback) { try { v.cancelVideoFrameCallback(R.vfc); } catch (e) {} }
      if (R.raf != null) { cancelAnimationFrame(R.raf); }
      if (reduce) { R.el.remove(); } else { R.el.classList.add('lrp-rt-out'); setTimeout(function () { R.el.remove(); }, 260); }
      root.classList.remove('lrp-rton', 'lrp-rtbm');
      lastLayout = 0;
    }
    /* the regions for this moment (layer px): one stage, or the two battle halves under the score bar */
    function rtGroups() {
      var W = root.clientWidth, H = root.clientHeight;
      if (!rt.bm) {
        var n = rt.ppl.length;
        return [{ x: 0, y: 0, w: W, h: H, pad: n === 1 ? 0 : RT_GAP, ppl: rt.ppl }];
      }
      var top = Math.max(RT_GAP, Math.min(H * 0.4, rt.top || 0)), hw = (W - RT_GAP) / 2;
      return [{ x: 0, y: top, w: hw + RT_GAP / 2, h: H - top, pad: RT_GAP, ppl: rt.halves[0], tagHost: false },
              { x: hw + RT_GAP / 2, y: top, w: W - hw - RT_GAP / 2, h: H - top, pad: RT_GAP, ppl: rt.halves[1], tagHost: true }];
    }
    /* once per render: the people at t -> the stage (built / re-placed / torn down). hit = the battle / link at t (or null) */
    function rtRender(t, jump, hit) {
      var halves = null, ppl = null;
      if (rtAllowed()) {
        if (mode === 'battle' && hit) { halves = rtHalvesAt(t, hit); }
        else if (mode === 'call') { ppl = rtPeopleAt(t); }
      }
      if (!ppl && !halves) { rtOff(); return; }
      var all = halves ? halves[0].concat(halves[1]) : ppl;
      var key = (halves ? 'B' + hit.b.id + ':' + halves[0].length + '|' : '') + all.map(function (p) { return p.k + ':' + p.state + ':' + (p.tl ? p.tl.x + ',' + p.tl.y + ',' + p.tl.w + ',' + p.tl.h : '-'); }).join('|');
      if (!rt) {
        rt = { el: el('div', 'lrp-rt'), bubbles: {}, key: '', n: 0, on: true, vfc: null, raf: null, draws: 0, instant: true, size: '', flips: 0, places: 0, bm: false, top: 0 };
        rt.el.setAttribute('aria-hidden', 'true');
        root.insertBefore(rt.el, root.firstChild);   // under the chat, the pills, the hearts, the gift stage, the battle bar
        root.classList.add('lrp-rton');
      }
      if (rt.key !== key) {
        if (jump) { rt.instant = true; }   // a seek landed on a different set of people: place them at once (only this placement)
        var regionWas = rt.bm || rt.n > 1;
        rt.key = key; rt.n = all.length; rt.ppl = ppl || all; rt.halves = halves; rt.bm = !!halves;
        root.classList.toggle('lrp-rtbm', rt.bm);
        if (regionWas !== (rt.bm || rt.n > 1) || rt.places === 0) { rt.pending = true; layout(); }   // the layer's region moves first (layout places)
        else { rtPlace(rtGroups()); }
      }
      rtLoop();
      if (v.paused || !v.requestVideoFrameCallback) { rtDraw(); }
    }
    /* from layout(), after the layer got its rect: a pending set of people is placed (animated); a plain resize re-places at once */
    function rtResize(under) {
      if (!rt || !rt.ppl) { return; }
      if (rt.bm && under != null && Math.abs(under - rt.top) > 1) { rt.top = under; rt.size = ''; }
      var sz = root.clientWidth + 'x' + root.clientHeight;
      if (rt.pending) { rt.pending = false; rtPlace(rtGroups()); return; }
      if (sz === rt.size) { return; }
      rt.instant = true;
      rtPlace(rtGroups());
    }

    /* ---------- THE CLIP MOVES HOUSE (2026-10-15, Rob on Dee's #2720 replay: "the chat and stuff disappears when I click full
       screen on web"): the feed card's fullscreen button on a PLAYING clip does not open a second player -- app.js flies the card's
       own <video> (card -> .pf-hero flight wrapper -> replaceChild into the viewer's media box) and close() can carry it back. The
       layer was appended to the parent the clip had when it first played and never followed it, so the viewer played the clip
       with its chat left behind in the (now empty) card. Every render checks the clip's parent: mid-flight the layer hides;
       landed somewhere new, the overlay is rebuilt in the new home (fresh host, fresh viewer/card rules, same shared rows). */
    function inFlight() {
      var p = v.parentElement;
      return !p || p === document.body || v.classList.contains('pf-hero') || !!(p.closest && p.closest('.pf-hero'));
    }
    function rehome() {
      if (inFlight()) { css(root, 'display', 'none'); return; }   // the landing re-parents it once more: wait for that
      detach();
      try { attach(v); } catch (e) { if (window.console) { console.warn('[replay overlay] rehome', e); } }
    }

    /* ---------- the render (once per timeupdate / seek, in one rAF) ---------- */
    function render() {
      pending = false;
      if (!alive) { return; }
      if (!v.isConnected || d.dead) { detach(); return; }
      if (v.parentElement !== h) { rehome(); return; }
      css(root, 'display', '');
      var t = now();
      var nowMs = Date.now();
      placeTog();
      ensure(d, t);
      if (!d.meta) { return; }
      var hit = battleAt(t);
      var jump = seekMode || (lastT >= 0 && Math.abs(t - lastT) > 2500);
      // a room / grid picture with no call window (the window comes from live_rt_members) is still a call when the recorded layout says so
      setMode(hit ? 'battle' : (callAt(t) || (rtAllowed() && rtPeopleAt(t)) ? 'call' : 'solo'), hit ? 'b' + hit.b.id : '');
      if (nowMs - lastLayout > 1000) { lastLayout = nowMs; layout(); }
      rtRender(t, seekMode, hit);   // only a real seek places the bubbles at once (a starved main thread's time gap still animates)
      if (hit) { renderBattle(t, hit); }
      renderPills(mode === 'call' && !rt ? t : -1);   // the re-tile draws its own name tags in the bubbles
      renderSkip(t);
      var rows = d.rows;
      var hi = lastAt(rows, t);
      var want = {};
      var pick = [];
      var maxRows = mode === 'battle' ? MAX_ROWS_STAGE : MAX_ROWS;
      // THE ROOM'S LIST: the newest lines before the playhead stay up until newer ones push them off (never timed out)
      var hs = history(d, t);
      for (var i = hi; i >= 0 && pick.length < maxRows; i--) {
        var r = rows[i];
        if (r.t_ms < hs.floor) { break; }
        pick.push(r);
      }
      if (pick.length < maxRows && hs.need >= 0 && hs.w2 - hs.need <= BACK_WINS && !d.dead && !(d.retryAt && Date.now() < d.retryAt)) { fetchWindow(d, hs.need, false); }
      pick.reverse();
      seekMode = false;
      lastT = t;
      feedGifts(t, jump);
      feedHearts(t, jump);
      placeChapters(t);
      for (var j = 0; j < pick.length; j++) {
        var rr = pick[j];
        var k = (rr.kind === 'gift' ? 'g' : 'c') + rr.id;
        want[k] = 1;
        var e = shown[k];
        if (!e) {
          e = rowEl(rr);
          shown[k] = e;
          if (!jump && !reduce) { e.classList.add('lrp-in'); requestAnimationFrame(function (x) { return function () { x.classList.remove('lrp-in'); }; }(e)); }
        }
      }
      for (var key in shown) {
        if (!want[key]) { var x = shown[key]; delete shown[key]; if (x.parentNode) { x.parentNode.removeChild(x); } }
      }
      // time order, oldest at the top: move a node only when it is out of place (usually nothing moves)
      for (var q = 0; q < pick.length; q++) {
        var node = shown[(pick[q].kind === 'gift' ? 'g' : 'c') + pick[q].id];
        if (list.children[q] !== node) { list.insertBefore(node, list.children[q] || null); }
      }
    }

    function kick() {
      if (pending || !alive) { return; }
      pending = true;
      requestAnimationFrame(render);
    }

    function onSeek() { seekMode = true; kick(); }
    function onMeta() { lastLayout = 0; kick(); }

    function onPlayState() { syncFreeze(); kick(); }

    function detach() {
      alive = false;
      v.removeEventListener('timeupdate', kick);
      v.removeEventListener('seeked', onSeek);
      v.removeEventListener('seeking', onSeek);
      v.removeEventListener('play', onPlayState);
      v.removeEventListener('playing', onPlayState);
      v.removeEventListener('pause', onPlayState);
      v.removeEventListener('ended', onPlayState);
      v.removeEventListener('loadedmetadata', onMeta);
      v.removeEventListener('resize', onMeta);
      window.removeEventListener('resize', onResize);
      if (ro) { try { ro.disconnect(); } catch (e) {} }
      if (mo) { try { mo.disconnect(); } catch (e) {} }
      if (io) { try { io.disconnect(); } catch (e) {} }
      var i = d.subs.indexOf(kick); if (i >= 0) { d.subs.splice(i, 1); }
      var oi = overlays.indexOf(api); if (oi >= 0) { overlays.splice(oi, 1); }
      clearHearts(); dropGifts(); dropChapters(); rtOff();
      callFit(false);
      if (root.parentNode) { root.parentNode.removeChild(root); }
      if (tog.parentNode) { tog.parentNode.removeChild(tog); }
      if (views) { views.delete(v); } else { v.__lrp = null; }
    }

    function onResize() { lastLayout = 0; chFit = false; kick(); }

    // a layer left in this box by a clip that is gone (the viewer's placeholder clip, retired when the flown card clip took its
    // place -- app.js replaceChild) goes first: never two chats over one picture
    overlays.slice().forEach(function (o) { if (o.host === h && o.video !== v && !o.video.isConnected) { o.detach(); } });
    h.appendChild(root);
    v.addEventListener('timeupdate', kick);
    v.addEventListener('seeked', onSeek);
    v.addEventListener('seeking', onSeek);
    v.addEventListener('play', onPlayState);
    v.addEventListener('playing', onPlayState);
    v.addEventListener('pause', onPlayState);
    v.addEventListener('ended', onPlayState);
    v.addEventListener('loadedmetadata', onMeta);
    v.addEventListener('resize', onMeta);
    window.addEventListener('resize', onResize, { passive: true });
    var ro = null;
    if (window.ResizeObserver) { try { ro = new ResizeObserver(function () { lastLayout = 0; chFit = false; kick(); }); ro.observe(h); } catch (e) { ro = null; } }
    var mo = null, pfEl = inPf && h.closest ? h.closest('.pfeed') : null;   // the chrome waking / resting moves the pills off / back onto the rail
    if (pfEl && window.MutationObserver) {
      try {
        mo = new MutationObserver(function () { if (pills) { lastLayout = 0; kick(); } });
        mo.observe(pfEl, { attributes: true, attributeFilter: ['class'] });
        var hfb = pfEl.querySelectorAll('.pf-hf-rep, .pf-hf-dock, .pf-hf-rate');
        for (var hi = 0; hi < hfb.length; hi++) { mo.observe(hfb[hi], { attributes: true, attributeFilter: ['hidden', 'class'] }); }
      } catch (e) { mo = null; }
    }
    // OFFSCREEN = frozen like paused (a feed card scrolled away while its clip still runs)
    if (window.IntersectionObserver) {
      try { io = new IntersectionObserver(function (es) { visible = es[es.length - 1].isIntersecting; syncFreeze(); }); io.observe(h); } catch (e) { io = null; }
    }
    d.subs.push(kick);
    var api = { kick: kick, detach: detach, root: root, host: h, video: v, data: d, now: now, mode: function () { return mode + (st && mode === 'battle' ? (st.seam ? ':seam' : ':over') : ''); },
                chat: function (on) { if (!on) { clearHearts(); dropGifts(); } else { fxT = now(); hT = now(); } kick(); },
                sync: syncFreeze,
                dbg: function () { return { pending: pending, lastT: lastT, alive: alive, rows: d.rows.length, meta: !!d.meta, shown: Object.keys(shown).length, conn: v.isConnected, mode: mode, geo: geo,
                                            frozen: frozen, visible: visible, fxT: fxT, hT: hT, gift: !!gd, heartNodes: HP.length, heartsBusy: HP.filter(function (p) { return !!p.a; }).length,
                                            hearts: d.hearts.length, chapters: chList().length, n: dbgN, giftDbg: gd ? gd.dbg : null,
                                            rt: rt ? { n: rt.n, key: rt.key, draws: rt.draws, flips: rt.flips, places: rt.places, size: rt.size, bubbles: Object.keys(rt.bubbles).map(function (k) { var B = rt.bubbles[k]; return { k: k, x: Math.round(B.x), y: Math.round(B.y), w: Math.round(B.w), h: Math.round(B.h), host: !!B.p.host, gone: B.gone, cw: B.cv.width, ch: B.cv.height, src: B.src }; }) } : null }; } };
    overlays.push(api);
    if (views) { views.set(v, api); } else { v.__lrp = api; }
    layout();
    syncFreeze();
    kick();
  }

  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || !v.hasAttribute('data-lreplay')) { return; }
    try { attach(v); } catch (x) { if (window.console) { console.warn('[replay overlay]', x); } }
  }, true);

  document.addEventListener('visibilitychange', function () { overlays.slice().forEach(function (o) { o.sync(); }); });

  window.__rovaReplay = {
    posts: posts,
    overlays: overlays,
    of: function (v) { return views ? views.get(v) : v && v.__lrp; },
    chatOn: function () { return chatOn; }
  };
})();
